// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-10-29T18:35:32.930Z
// Property: Crescent Valley (ID: 6767906449167570)
// Collections: 22 amenities, 3 floorplans (live), 34 photos, 44 POIs, 5 reviews, 3 virtual tours, 6 office hours, 1 special offers (live), 20 faqs
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162464",
  "multihub_property_id": "6767906449167570",
  "property_external_id": "1896316",
  "property_zillow_url": "https://www.zillow.com/apartments/gainesville-ga/crescent-valley/CmGvNP/",
  "property_apartments_url": "https://www.apartments.com/crescent-valley-gainesville-ga/9pw5cf4/",
  "property_google_business_url": "https://www.google.com/maps/place/Crescent+Valley+-+by+Quinn+Residences/@34.323983,-83.791353,945m/data=!3m2!1e3!4b1!4m6!3m5!1s0x88f5f79c3b046009:0xfc05472ee6b9d3e4!8m2!3d34.323983!4d-83.791353!16s%2Fg%2F11w_j2dhq4?entry=ttu&g_ep=EgoyMDI2MDkyMC4wIKXMDSoASAFQAw%3D%3D",
  "property_linkedin_url": null,
  "property_hubspot_id": "57142570538",
  "property_crm_software": "RentCafe Yardi",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "crescent-valley",
  "property_name": "Crescent Valley",
  "property_website_url": "https://www.crescentvalleyhomes.com/",
  "property_domain": "https://www.crescentvalleyhomes.com/",
  "property_address": "504 John Harm Way",
  "property_full_address": "504 John Harm Wy, Gainesville, GA 30501",
  "property_address_1": "504 John Harm Wy",
  "property_address_2": null,
  "property_address_city": "Gainesville",
  "property_address_state": "GA",
  "property_address_zip_full": "30501",
  "property_address_zip": "30501",
  "property_address_country": "US",
  "property_address_county": "Hall County",
  "property_neighborhood_address": "Gainesville",
  "property_address_latitude": "34.323983",
  "property_address_longitude": "-83.791353",
  "property_email": "quinley@quinnresidences-leasing.com",
  "property_phone": "(844) 403-0369",
  "property_call_tracking_phone": "844-968-3115",
  "property_company_name": "Quinn Residences",
  "property_company_url": "https://www.quinnmgmt.com",
  "agency_contacts": null,
  "property_type": "Townhomes",
  "property_short_description": "<p><strong>Modern Gainesville townhome living, connected to more.</strong> Explore newly built three- and four-bedroom layouts with polished finishes, smart-home touches, and garage options—then schedule a tour to see Crescent Valley in person.</p>",
  "property_long_description": "<p><strong>Modern Gainesville townhome living, connected to more.</strong> Crescent Valley brings newly built three- and four-bedroom townhome-style layouts to a convenient location just off I-985, with quick access to Downtown Gainesville, Lake Lanier, and the everyday shopping and dining that keep your week moving. Inside, you’ll find polished details that feel fresh from day one: granite countertops, stainless steel appliances, high ceilings, luxury flooring, large closets, in-unit laundry, smart-home technology, and garage options.</p><p>Beyond your front door, the community makes it easy to shift from errands to downtime with a clubhouse, pool, pickleball court, courtyard, lawn care, on-site management, and a pet park for four-legged roommates. When you’re ready to explore, head toward the Historic Downtown Gainesville Square for local restaurants and events, walk the Rock Creek Greenway, or spend the day near Lake Lanier Olympic Park. Browse current <a href=\"/floor-plans\">floor plans</a>, explore the <a href=\"/amenities\">amenities</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to see Crescent Valley in person.</p>",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583a-8f65-702d-990d-0388a0525717.webp",
  "property_featured_image_media": {
    "alt_text": "Modern kitchen with light blue cabinets, granite countertops, and stainless steel appliances.",
    "public_id": "01a1583a-8f65-702d-990d-0388a0525717",
    "storage_key": "property/6767906449167570/01a1583a-8f65-702d-990d-0388a0525717.webp",
    "width": 3072,
    "height": 2048
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449167570/019faec0-12dc-7472-a6e8-e60bfe9ae776.mp4",
  "property_featured_video_media": {
    "public_id": "019faec0-12dc-7472-a6e8-e60bfe9ae776",
    "storage_key": "property/6767906449167570/019faec0-12dc-7472-a6e8-e60bfe9ae776.mp4",
    "thumbnail_key": "property/6767906449167570/019faec0-12dc-7472-a6e8-e60bfe9ae776_thumb.webp",
    "size_bytes": 5901402,
    "classification": "Community",
    "title": "Explore Our Beautiful Townhome Community",
    "description": "Discover our vibrant townhome community, offering modern living spaces with charming exteriors and convenient amenities. Perfect for those seeking comfort and style."
  },
  "property_total_units": "143",
  "property_year_built": "2025",
  "property_year_renovated": null,
  "property_walk_score": "15",
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "90.20979020979021",
  "property_admin_fee": "350",
  "property_application_fee": "100",
  "property_fees_deposit_info": "Security deposit varies with application screening; a security deposit alternative is available. Required monthly charges: utility billing $11.99, concierge $10.95, landscaping $80, smart home package $35; renters insurance required. Application fee $100 per adult applicant; administrative fee $350 (one-time). See the Easy Fee Guide for the full schedule.",
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "300",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "35",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet; no more than two pets without written approval.",
  "property_pet_policy_description": "Dogs and cats welcome, up to two pets. One-time pet fee $300 for one pet, $500 for two. Pet rent $35 per pet per month. 100-lb weight limit and breed restrictions apply.",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://crescentvalleyhomes.securecafe.com/onlineleasing/crescent-valley0/floorplans.aspx",
  "property_resident_portal_url": "https://crescentvalleyhomes.securecafenet.com/residentservices/crescent-valley0/userlogin",
  "property_apply_now_url": "https://crescentvalleyhomes.securecafe.com/onlineleasing/crescent-valley0/guestlogin.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a0cf90-5264-7709-970b-062e5ba6d103.webp",
  "property_primary_logo_media": {
    "alt_text": "Crescent Valley by Quinn Residences logo",
    "public_id": "01a0cf90-5264-7709-970b-062e5ba6d103",
    "storage_key": "property/6767906449167570/01a0cf90-5264-7709-970b-062e5ba6d103.webp",
    "width": 1000,
    "height": 491
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a0cf90-3438-7538-a9c0-6739f7b9337f.webp",
  "property_secondary_logo_media": {
    "alt_text": "Crescent Valley by Quinn Residences logo",
    "public_id": "01a0cf90-3438-7538-a9c0-6739f7b9337f",
    "storage_key": "property/6767906449167570/01a0cf90-3438-7538-a9c0-6739f7b9337f.webp",
    "width": 1000,
    "height": 490
  },
  "property_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a0cf8f-9aad-70cd-8e96-60d798f902cc.webp",
  "property_icon_media": {
    "alt_text": "Crescent moon with wavy lines inside",
    "public_id": "01a0cf8f-9aad-70cd-8e96-60d798f902cc",
    "storage_key": "property/6767906449167570/01a0cf8f-9aad-70cd-8e96-60d798f902cc.webp",
    "width": 2001,
    "height": 2000
  },
  "property_fav_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a0cf8f-9aad-70cd-8e96-60d798f902cc.webp",
  "property_fav_icon_media": {
    "alt_text": "Crescent moon with wavy lines inside",
    "public_id": "01a0cf8f-9aad-70cd-8e96-60d798f902cc",
    "storage_key": "property/6767906449167570/01a0cf8f-9aad-70cd-8e96-60d798f902cc.webp",
    "width": 2001,
    "height": 2000
  },
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a0cf90-5264-7709-970b-062e5ba6d103.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Crescent Valley by Quinn Residences logo",
    "public_id": "01a0cf90-5264-7709-970b-062e5ba6d103",
    "storage_key": "property/6767906449167570/01a0cf90-5264-7709-970b-062e5ba6d103.webp",
    "width": 1000,
    "height": 491
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a0cf90-3438-7538-a9c0-6739f7b9337f.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Crescent Valley by Quinn Residences logo",
    "public_id": "01a0cf90-3438-7538-a9c0-6739f7b9337f",
    "storage_key": "property/6767906449167570/01a0cf90-3438-7538-a9c0-6739f7b9337f.webp",
    "width": 1000,
    "height": 490
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/01a0abc9-4cac-75ae-8a34-d20271f4bca8.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-2459-730d-9320-edaae039913a.webp",
  "property_company_logo_media": {
    "alt_text": "Quinn Residences logo",
    "public_id": "019fa983-2459-730d-9320-edaae039913a",
    "storage_key": "company/5767906449162464/019fa983-2459-730d-9320-edaae039913a.webp",
    "width": 2161,
    "height": 964
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162464/019fa983-24c1-74dc-8eb8-8eb0b71b3a84.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "Quinn Residences logo.",
    "public_id": "019fa983-24c1-74dc-8eb8-8eb0b71b3a84",
    "storage_key": "company/5767906449162464/019fa983-24c1-74dc-8eb8-8eb0b71b3a84.webp",
    "width": 2161,
    "height": 964
  },
  "property_primary_color": "#536670",
  "property_secondary_color": "#bb9e82",
  "property_font_color": "#606161",
  "property_color_4": null,
  "property_color_3": "#c6a386",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "3 - 4",
  "property_bedrooms_min": "3",
  "property_bedrooms_max": "4",
  "property_bathrooms_range": "2.5 - 3.5",
  "property_bathrooms_min": "2.5",
  "property_bathrooms_max": "3.5",
  "property_sqft_range": "1668 - 2108",
  "property_sqft_min": "1668",
  "property_sqft_max": "2108",
  "property_price_range": "1999 - 2588",
  "property_price_min": "2111",
  "property_price_max": "2588",
  "property_available_units": 15,
  "property_facebook_url": "https://www.facebook.com/profile.php?id=61572352091597",
  "property_instagram_url": "https://www.instagram.com/crescentvalleyhomes/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJCWAEO5z39YgR5NO55i5HBfw",
  "property_youtube_url": null,
  "property_yelp_url": null,
  "property_tiktok_url": null,
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Crescent Valley",
  "property_home_romance_title": "Brand new Townhomes for Rent in Gainesville, GA",
  "property_home_amenities_blurb": "<p><strong>Everyday ease, with extra room to unwind.</strong> Crescent Valley pairs smart-home features, in-unit laundry, generous closets, and garage options with polished finishes like granite countertops, stainless steel appliances, high ceilings, and luxury flooring. Beyond your front door, enjoy a clubhouse, pool, pickleball court, courtyard, lawn care, and pet park—all designed to make downtime feel effortless in Gainesville.</p>",
  "property_home_floorplans_blurb": "<p><strong>Townhome-style space with modern ease.</strong> Crescent Valley offers three- and four-bedroom floor plans in Gainesville with open living areas, generous closets, in-home laundry, and available garage options. Granite countertops, stainless steel appliances, high ceilings, luxury flooring, and smart-home features bring a polished finish to everyday living. Compare layouts, check availability, and find the space that fits how home needs to work.</p>",
  "property_home_gallery_blurb": "<p><strong>Take a closer look at Crescent Valley.</strong> Preview townhomes with granite countertops, stainless steel appliances, high ceilings, luxury flooring, and patios that open the layout outdoors. Then explore the pool, clubhouse, pickleball court, pet park, and more in the full gallery.</p>",
  "property_home_neighborhood_blurb": "<p><strong>Gainesville access with North Georgia energy.</strong> Crescent Valley puts I-985, Historic Downtown Gainesville, Atlas Pizza, Avocados, and First Friday concerts within easy reach, with Midland and Rock Creek greenways nearby for fresh-air time. Add Atlanta Botanical Garden Gainesville, lake-area happenings, WeGo rideshare transit, and the Gainesville Trolley, and your local map opens up fast.</p>",
  "property_home_reviews_blurb": "<p><strong>Residents praise the Crescent Valley experience</strong>, from beautiful, welcoming townhome spaces to a leasing team known for patient, detailed guidance. Reviews call out helpful tours with William, clear answers from Ana, and a service style that feels friendly, informative, and never rushed.</p><p>Read more to see what stands out in everyday feedback from Crescent Valley residents.</p>",
  "property_neighborhood_blurb": "<p><strong>North Georgia days, Gainesville convenience.</strong> From Crescent Valley, your map opens to an easy mix of errands, eats, and time outside: hop on I-985 for regional access, head into Historic Downtown Gainesville for sidewalk cafés, boutiques, First Friday concerts, and local favorites like Atlas Pizza or Avocados, or trade pavement for paths along the Midland and Rock Creek greenways.</p><p>Weekends can stretch from artful strolls at Atlanta Botanical Garden Gainesville to lake-area events and fresh-air plans, with WeGo rideshare transit and the Gainesville Trolley adding more ways to move around town. Explore the neighborhood map, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Crescent Valley places everyday life close to the local spots you’ll want on repeat.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p><strong>Amenities with room to breathe.</strong> At Crescent Valley, the everyday conveniences feel built into the rhythm of home: smart-home technology, in-unit laundry, generous closets, garage options, and polished finishes like granite countertops, stainless steel appliances, high ceilings, and luxury flooring.</p><p>Step outside and the community keeps downtime easy, with a clubhouse, pool, pickleball court, courtyard, lawn care, and a pet park that adds more ways to enjoy life at home in Gainesville. Preview the spaces in the <a href=\"/gallery\">photo gallery</a>, compare your favorite <a href=\"/floor-plans\">townhome-style layouts</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to experience the details in person.</p>",
  "property_applynow_blurb": "<p><strong>Start your next chapter at Crescent Valley.</strong> Apply online for newly built three- and four-bedroom townhome-style layouts with granite countertops, stainless steel appliances, high ceilings, smart-home technology, in-unit laundry, and garage options—all in a connected Gainesville location just off I-985.</p>",
  "property_contactus_blurb": "<p><strong>Have questions or need directions?</strong> The Crescent Valley leasing team is here to help you connect with newly built townhome living just off I-985. Reach out for details, guidance, or help planning your visit to see the community in person.</p>",
  "property_faqs_blurb": "<p><strong>Questions about Crescent Valley?</strong> Start here for quick answers about townhome-style layouts, leasing, smart-home features, pet-friendly spaces, and everyday life in the community. If you need more details or want help choosing your next step, the leasing team is happy to help.</p>",
  "property_floorplans_blurb": "<p><strong>Find the layout that fits your next chapter at Crescent Valley.</strong> Choose from spacious three- and four-bedroom townhome-style floor plans in Gainesville, each designed with the everyday details that make a home feel easy from move-in day. Open living areas give you room to relax, gather, or work from home, while generous closets, in-home laundry, and garage options help keep daily routines organized.</p><p>Inside, polished finishes like granite countertops, stainless steel appliances, high ceilings, luxury flooring, and smart-home features add a modern edge without overcomplicating your space. Browse current availability, compare bedroom and bath options, then explore the <a href=\"/gallery\">photo gallery</a> or <a href=\"/schedule-a-tour\">schedule a tour</a> to see your favorite Crescent Valley floor plan in person.</p>",
  "property_gallery_blurb": "<p><strong>See Crescent Valley from the inside out.</strong> Browse photos that bring these townhomes into focus: bright kitchens with granite countertops and stainless steel appliances, open living areas with high ceilings and luxury flooring, and patios that extend your space outdoors.</p><p>As you move through the gallery, picture the details that shape everyday living—the clean lines of modern finishes, the ease of in-home laundry, and community moments around the pool, clubhouse, pickleball court, and pet park. Like what you see? Compare <a href=\"/floor-plans\">available floor plans</a>, explore more <a href=\"/amenities\">features and finishes</a>, or <a href=\"/schedule-a-tour\">schedule a tour</a> to view Crescent Valley in person.</p>",
  "property_interactivemap_blurb": "<p><strong>Find your place on the map.</strong> Explore Crescent Valley’s available three- and four-bedroom townhome-style layouts, then zoom out to see how this Gainesville location connects you to I-985, Downtown Gainesville, Lake Lanier, and everyday shopping and dining.</p>",
  "property_pets_blurb": "<p><strong>Pet-friendly routines start right outside your door.</strong> At Crescent Valley, cats and dogs have space to settle in while you enjoy the ease of townhome-style living. Take daily walks through the community, let your pup stretch out at the on-site <a href=\"/amenities\">pet park</a>, then come home to practical details like a patio, large closets, in-home laundry, and low-maintenance finishes that help keep life with pets running smoothly.</p><p>When you’re ready to roam, Gainesville offers pup-friendly parks, trails, and off-leash spots close enough for a quick outing or a longer weekend walk. Review the pet policy details below, then <a href=\"/schedule-a-tour\">schedule a tour</a> to see how Crescent Valley can fit your four-legged routine.</p>",
  "property_referafriend_blurb": "<p><strong>Share Crescent Valley with a friend.</strong><br>Love the fresh townhome feel, smart-home details, garage options, and easy access to what keeps Gainesville moving? Invite a friend to explore newly built three- and four-bedroom layouts and see why Crescent Valley is worth passing along.</p>",
  "property_residentaccess_blurb": "<p><strong>Resident Access at Crescent Valley.</strong> Pay rent, submit maintenance requests, and manage your account in one convenient place—so daily details stay as streamlined as your modern townhome living.</p>",
  "property_reviews_blurb": "<p><strong>See Crescent Valley through resident experiences.</strong> Reviews often highlight the welcoming feel of the community, beautiful townhome spaces, and a leasing team that takes time to answer questions in detail.</p><p>From helpful tours with William to clear, friendly guidance from Ana, visitors describe service that feels patient, informative, and unpressured. One reviewer summed up the homes as “beautiful and welcoming,” while another appreciated being able to take their time during the tour.</p><p>Browse the ratings and comments below to get a real sense of what stands out at Crescent Valley.</p>",
  "property_created_at": "1785257638989",
  "property_scheduletour_blurb": "<p><strong>See Crescent Valley up close.</strong> Tour newly built three- and four-bedroom townhome-style layouts with fresh finishes, smart-home technology, in-unit laundry, and garage options. Explore the spaces, picture the everyday flow, and book your visit when you’re ready to experience it in person.</p>",
  "property_thankyou_blurb": "<p><strong>Thank you—we’ve received your inquiry.</strong><br>Our leasing team will be in touch soon to help with your next step. Crescent Valley brings modern Gainesville townhome living together with fresh finishes, smart-home technology, in-unit laundry, and community spaces designed for easy everyday downtime.</p>",
  "property_virtualtours_blurb": null,
  "property_copyright": "2026 All Rights Reserved. Crescent Valley",
  "property_seo_title_home": "Crescent Valley |  Apartments in Gainesville, GA",
  "property_seo_description_home": "Discover luxury living at Crescent Valley in Gainesville, GA, with spacious floor plans, a pet park, and a pickleball court. Your perfect home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Gainesville, GA Apartments for Rent",
  "property_seo_description_floorplans": "Find your ideal home at Crescent Valley in Gainesville, GA! Choose from spacious three or four-bedroom floor plans designed for comfort and style.",
  "property_seo_title_amenities": "Amenities | Gainesville, GA Apartments for Rent",
  "property_seo_description_amenities": "Experience Crescent Valley in Gainesville, GA—your go-to for luxurious living with smart-home tech, a pet park, pickleball court, and spacious floor plans.",
  "property_seo_title_gallery": "Gallery | Apartments in Gainesville, GA",
  "property_seo_description_gallery": "Picture your life at Crescent Valley in Gainesville, GA! Enjoy luxury amenities, spacious floor plans, and a pet-friendly environment with smart-home tech.",
  "property_seo_title_virtualtours": "Virtual Tours | Crescent Valley Apartments",
  "property_seo_description_virtualtours": "Experience Crescent Valley in Gainesville, GA! Take a virtual tour of our spacious three & four-bedroom apartments and envision your new home today!",
  "property_seo_title_interactivemap": "Interactive Map | Crescent Valley Apartments",
  "property_seo_description_interactivemap": "Discover your dream home at Crescent Valley, Gainesville, GA! Enjoy luxury amenities like a pool, pet park, and interactive community map!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Gainesville, GA",
  "property_seo_description_neighborhood": "Experience life in Gainesville at Crescent Valley! Uncover local favorites, hidden gems, and vibrant hotspots just steps from your new home. Join us today!",
  "property_seo_title_contact": "Contact Us | Crescent Valley",
  "property_seo_description_contact": "Contact Crescent Valley's leasing team to find your perfect home among our three- and four-bedroom floor plans!",
  "property_seo_title_faqs": "FAQs | Apartments in Gainesville, GA",
  "property_seo_description_faqs": "Find answers to your questions about Crescent Valley in Gainesville, GA. See our luxury amenities, spacious floor plans, and pet-friendly options.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Gainesville, GA",
  "property_seo_description_reviews": "Join the vibrant community at Crescent Valley in Gainesville, GA! Check out resident reviews and see why our luxury amenities and pet-friendly homes shine.",
  "property_seo_title_applynow": "Apply Now | Apartments in Gainesville, GA",
  "property_seo_description_applynow": "Experience luxury living at Crescent Valley in Gainesville, GA. With spacious floors, modern amenities, and a pet-friendly atmosphere, your dream home awaits!",
  "property_seo_title_residentaccess": "Resident Access | Crescent Valley",
  "property_seo_description_residentaccess": "Welcome to Crescent Valley in Gainesville, GA. Log in to your resident portal for hassle-free rent payments, maintenance requests, and community updates!",
  "property_seo_title_referafriend": "Refer A Friend | Crescent Valley",
  "property_seo_description_referafriend": "Great friends make great neighbors at Crescent Valley in Gainesville, GA! Refer a friend today and let them experience our vibrant community and cozy living.",
  "property_seo_title_scheduletour": "Schedule a Tour | Crescent Valley",
  "property_seo_description_scheduletour": "Discover Crescent Valley in Gainesville, GA! Schedule your tour today for a vibrant community with modern amenities and scenic beauty.",
  "property_seo_title_privacy": "Privacy Policy | Crescent Valley",
  "property_seo_description_privacy": "At Crescent Valley, Gainesville, GA, your privacy matters. Check our transparent policies to see how we protect your information!",
  "property_seo_title_accessibility": "Website Accessibility | Crescent Valley",
  "property_seo_description_accessibility": "At Crescent Valley in Gainesville, GA, we prioritize accessibility for all. Experience a community designed for inclusivity—where everyone feels at home.",
  "property_seo_title_sitemap": "Sitemap | Crescent Valley",
  "property_seo_description_sitemap": "Navigate the charm of Crescent Valley in Gainesville, GA. Check our sitemap to uncover everything our stunning apartment community has to offer!",
  "property_seo_title_thankyou": "Thank You | Crescent Valley",
  "property_seo_description_thankyou": "Thank you for contacting Crescent Valley in Gainesville, GA! We’ll be in touch soon to help you find your perfect home.",
  "property_seo_title_pets": "Pet Policy | Apartments in Gainesville, GA",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793289714137",
  "amenities": [
    {
      "id": "ec_57ca163ad81bc75d9aee56f6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "yardi",
      "external_id": "123299519",
      "title": "On-Site Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b56902a59f43ba47d2b207ea",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "yardi",
      "external_id": "123299520",
      "title": "On-Site Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_24a71c4f1391536c485e78c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "yardi",
      "external_id": "123299518",
      "title": "Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_c8f730e477e14445229db371",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "yardi",
      "external_id": "123299516",
      "title": "Garage",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_5fbdc0cfc44414425af1ae32",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "yardi",
      "external_id": "123299517",
      "title": "Green Building",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_545ef6ae1f0a24ceea75efb3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "yardi",
      "external_id": "122954487",
      "title": "Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_8fe5706e1476f90a64f214c1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "yardi",
      "external_id": "122954488",
      "title": "Pool",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_285bd5cdfea47d4a79b39ed5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "yardi",
      "external_id": "122954489",
      "title": "Playground",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_01e2dc408454cfce2f5bcd97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "yardi",
      "external_id": "123299525",
      "title": "Large Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_353bc12d5962f20b2197ea8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "yardi",
      "external_id": "123299523",
      "title": "High Ceilings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_568ad73e824dea301ab271d8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "yardi",
      "external_id": "123299521",
      "title": "Cable Ready",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b1f3bfc90ee290301d5f66ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "yardi",
      "external_id": "123299522",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_869ac5304fe5fc8848cfcf09",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "yardi",
      "external_id": "122954503",
      "title": "Stainless Steel Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3bd5cd9b93118a3f8f01240f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "yardi",
      "external_id": "122954506",
      "title": "Luxury Flooring",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_54bf8cf0a534fc1c4795ed8f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "yardi",
      "external_id": "122954505",
      "title": "Smart-Home Technology",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_eea0c7073981512b67ff27be",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "yardi",
      "external_id": "122954511",
      "title": "In-Unit Laundry",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_a726864184cd04523f971181",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "yardi",
      "external_id": "123299524",
      "title": "Patio/Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f9dfb2a75c2765755dee4614",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "yardi",
      "external_id": "122992204",
      "title": "Granite Countertops",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6145cc20ef125c04b911df23",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "yardi",
      "external_id": "122954492",
      "title": "Dog Park",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_fb141685ca29650659533b75",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "yardi",
      "external_id": "122954495",
      "title": "Pickleball Court",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_bc743d860d9b161db5edb384",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "yardi",
      "external_id": "122954497",
      "title": "Lawn Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_716a7ccf71a912ab2af14dd5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "yardi",
      "external_id": "122954499",
      "title": "Security Deposit Alternative",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "false",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "ec_fbea0b656cdd1c174af4157e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583a-8f65-702d-990d-0388a0525717.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light blue cabinets, granite countertops, and stainless steel appliances.",
        "public_id": "01a1583a-8f65-702d-990d-0388a0525717",
        "storage_key": "property/6767906449167570/01a1583a-8f65-702d-990d-0388a0525717.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious and modern kitchen featuring light blue cabinetry, granite countertops, an island with a double sink, and stainless steel appliances, perfect for cooking and entertaining.",
      "link": "false",
      "alt_text": "A modern kitchen with granite countertops and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/ModelUnit-2.jpg"
    },
    {
      "id": "ec_8c4388c2df3eda8fbcfcdc7b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583a-bfff-701d-aeb6-b5c5682e34a5.webp",
      "image_media": {
        "alt_text": "Exterior view of a row of colorful townhomes with garages under a blue sky with clouds.",
        "public_id": "01a1583a-bfff-701d-aeb6-b5c5682e34a5",
        "storage_key": "property/6767906449167570/01a1583a-bfff-701d-aeb6-b5c5682e34a5.webp",
        "width": 3072,
        "height": 1616
      },
      "title": "Community",
      "description": "Showcasing the vibrant exterior of our townhome community, featuring colorful facades and convenient garage access.",
      "link": "false",
      "alt_text": "A row of houses with different colored exteriors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Exterior-11.jpg"
    },
    {
      "id": "ec_674ed2a4fa7c8b723928ba01",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583a-c45f-74cb-89ed-bf74640df58c.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and a covered seating area.",
        "public_id": "01a1583a-c45f-74cb-89ed-bf74640df58c",
        "storage_key": "property/6767906449167570/01a1583a-c45f-74cb-89ed-bf74640df58c.webp",
        "width": 3072,
        "height": 1933
      },
      "title": "Community",
      "description": "Dive into luxury at our resort-style swimming pool, complete with comfortable lounge chairs and a shaded cabana for ultimate relaxation.",
      "link": "false",
      "alt_text": "A large swimming pool with a building in the background.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Pool-2.jpg"
    },
    {
      "id": "ec_f7fc9e90eb7eb27e02d4cdc4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583a-b2ed-76e3-9828-c5dc6274ad83.webp",
      "image_media": {
        "alt_text": "Modern open-concept living room and kitchen with sectional sofa, dining table, and island.",
        "public_id": "01a1583a-b2ed-76e3-9828-c5dc6274ad83",
        "storage_key": "property/6767906449167570/01a1583a-b2ed-76e3-9828-c5dc6274ad83.webp",
        "width": 3072,
        "height": 1981
      },
      "title": "Apartment",
      "description": "Spacious open-concept living area seamlessly connected to a modern kitchen, perfect for entertaining or relaxing.",
      "link": "false",
      "alt_text": "A modern kitchen and living room with a large island and a dining table.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/ModelUnit-1.jpg"
    },
    {
      "id": "ec_edbaf175e276e3fd771f582b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583a-b1a5-76b5-9e13-d85fe1229009.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light blue cabinets, granite countertops, stainless steel appliances, and an island with bar stools.",
        "public_id": "01a1583a-b1a5-76b5-9e13-d85fe1229009",
        "storage_key": "property/6767906449167570/01a1583a-b1a5-76b5-9e13-d85fe1229009.webp",
        "width": 3072,
        "height": 2058
      },
      "title": "Apartment",
      "description": "Step into this beautifully designed kitchen, featuring sleek light blue cabinetry, elegant granite countertops, and top-of-the-line stainless steel appliances. The spacious island with comfortable bar stools is perfect for casual dining or entertaining guests.",
      "link": "false",
      "alt_text": "A kitchen with a granite countertop and bar stools.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/ModelUnit-5.jpg"
    },
    {
      "id": "ec_c91352aee4d3813db133e548",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583a-b45b-756d-a88d-2033797f754a.webp",
      "image_media": {
        "alt_text": "Modern kitchen with light gray cabinets, granite countertops, stainless steel appliances, and an island.",
        "public_id": "01a1583a-b45b-756d-a88d-2033797f754a",
        "storage_key": "property/6767906449167570/01a1583a-b45b-756d-a88d-2033797f754a.webp",
        "width": 3072,
        "height": 2042
      },
      "title": "Apartment",
      "description": "Step into this beautifully appointed kitchen, featuring elegant granite countertops, ample cabinet space, and modern stainless steel appliances, perfect for culinary adventures.",
      "link": "false",
      "alt_text": "A modern kitchen with a large island and stainless steel appliances.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/ModelUnit-8.jpg"
    },
    {
      "id": "ec_671c06402e3dcb7bf1babad6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019faa35-6843-73de-9e93-4ef157d24042.webp",
      "image_media": {
        "alt_text": "Thermostat and light switches on wall with view of kitchen counter and cabinets",
        "public_id": "019faa35-6843-73de-9e93-4ef157d24042",
        "storage_key": "property/6767906449167570/019faa35-6843-73de-9e93-4ef157d24042.webp",
        "width": 856,
        "height": 616
      },
      "title": "Apartment",
      "description": "Modern kitchen with granite countertops, stainless steel appliances, and a large island. Includes wall-mounted thermostat and light switches for convenient control.",
      "link": "false",
      "alt_text": "A white wall with a switch and a white box on it.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Amenity%20-%20Smart%20Home.jpg"
    },
    {
      "id": "ec_8ae8c59c459ce0ea7db87a90",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583a-dfb6-775e-863f-9890c6e2425b.webp",
      "image_media": {
        "alt_text": "A wooden desk with a leather chair in a bright room.",
        "public_id": "01a1583a-dfb6-775e-863f-9890c6e2425b",
        "storage_key": "property/6767906449167570/01a1583a-dfb6-775e-863f-9890c6e2425b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "A cozy home office space featuring a wooden desk and chair, perfect for remote work or study. Includes a decorative lamp and plant for a touch of style.",
      "link": "false",
      "alt_text": "A room with a desk and a plant.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/ModelUnit-24.jpg"
    },
    {
      "id": "ec_c471b8ab8f67f45ec5e19c0e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583a-e287-7229-a6e8-1f1662c9fc64.webp",
      "image_media": {
        "alt_text": "Bedroom with a large bed, dresser, and ceiling fan.",
        "public_id": "01a1583a-e287-7229-a6e8-1f1662c9fc64",
        "storage_key": "property/6767906449167570/01a1583a-e287-7229-a6e8-1f1662c9fc64.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bedroom featuring a comfortable king-sized bed with plush pillows, a modern dresser with a mirror, and a convenient ceiling fan for year-round comfort.",
      "link": "false",
      "alt_text": "A bedroom with a bed, dresser, and mirror.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/ModelUnit-18.jpg"
    },
    {
      "id": "ec_46109ad716998bd59cde155d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583a-e3d1-77a9-96b0-ea0d59d7fa82.webp",
      "image_media": {
        "alt_text": "Modern bathroom with granite countertop vanity, toilet, and glass-enclosed shower.",
        "public_id": "01a1583a-e3d1-77a9-96b0-ea0d59d7fa82",
        "storage_key": "property/6767906449167570/01a1583a-e3d1-77a9-96b0-ea0d59d7fa82.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Enjoy the spacious and modern bathroom featuring a granite countertop vanity, a private glass-enclosed shower, and elegant fixtures.",
      "link": "false",
      "alt_text": "A bathroom with a sink, toilet, and shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/ModelUnit-20.jpg"
    },
    {
      "id": "ec_dd9aa8fdc32b27e7ee052a28",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583a-ef44-72d3-9938-3b69781b01f6.webp",
      "image_media": {
        "alt_text": "Bathroom with double vanity and toilet",
        "public_id": "01a1583a-ef44-72d3-9938-3b69781b01f6",
        "storage_key": "property/6767906449167570/01a1583a-ef44-72d3-9938-3b69781b01f6.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and spacious bathroom featuring a double vanity with granite countertops, a large mirror, and a comfortable toilet.",
      "link": "false",
      "alt_text": "A bathroom with a sink, mirror, and toilet.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/ModelUnit-17.jpg"
    },
    {
      "id": "ec_8ccdbc73d18c57f53c9454f5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583a-f909-709f-b128-1fc0a8f91922.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with wire shelving.",
        "public_id": "01a1583a-f909-709f-b128-1fc0a8f91922",
        "storage_key": "property/6767906449167570/01a1583a-f909-709f-b128-1fc0a8f91922.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with ample wire shelving for all your storage needs. Organize your belongings with ease.",
      "link": "false",
      "alt_text": "Empty room with white walls and wooden floor.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/ModelUnit-16.jpg"
    },
    {
      "id": "ec_0463ea644dddfd14727317ac",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-1114-7189-84d6-8f17360d28da.webp",
      "image_media": {
        "alt_text": "Double vanity bathroom with granite countertops and a large mirror reflecting a bedroom.",
        "public_id": "01a1583b-1114-7189-84d6-8f17360d28da",
        "storage_key": "property/6767906449167570/01a1583b-1114-7189-84d6-8f17360d28da.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Modern double vanity bathroom featuring granite countertops, dual sinks, and ample lighting. The large mirror offers a glimpse into the adjoining bedroom.",
      "link": "false",
      "alt_text": "A bathroom with a granite countertop and two sinks.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/ModelUnit-22.jpg"
    },
    {
      "id": "ec_0d1e5e5dc405db2211960c6e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-16b9-742e-b352-62f9d96bdd01.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed, nightstand, and closet.",
        "public_id": "01a1583b-16b9-742e-b352-62f9d96bdd01",
        "storage_key": "property/6767906449167570/01a1583b-16b9-742e-b352-62f9d96bdd01.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, featuring a plush queen-size bed and convenient closet space.",
      "link": "false",
      "alt_text": "A bedroom with a bed, nightstand, and lamp.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/ModelUnit-29.jpg"
    },
    {
      "id": "ec_ec563099c3c43c94e682ecec",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-146b-725e-bf09-c5188adb72fa.webp",
      "image_media": {
        "alt_text": "Modern bathroom with a gray vanity, granite countertop, and white subway tile shower surround.",
        "public_id": "01a1583b-146b-725e-bf09-c5188adb72fa",
        "storage_key": "property/6767906449167570/01a1583b-146b-725e-bf09-c5188adb72fa.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Stylish bathroom featuring a gray vanity with a granite countertop, a shower/tub combo with white subway tile, and modern fixtures.",
      "link": "false",
      "alt_text": "A bathroom with a toilet, sink, and shower.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/ModelUnit-25.jpg"
    },
    {
      "id": "ec_0a9a6eebc9d91a14231b8532",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-1854-77ef-9a0e-bf4da3efbfe0.webp",
      "image_media": {
        "alt_text": "A child's bedroom with a twin bed featuring a sun-themed comforter and a rainbow accent pillow.",
        "public_id": "01a1583b-1854-77ef-9a0e-bf4da3efbfe0",
        "storage_key": "property/6767906449167570/01a1583b-1854-77ef-9a0e-bf4da3efbfe0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Bright and cheerful child's bedroom with a fun sun comforter and decorative rainbow accents. Perfect for creating a happy and playful space.",
      "link": "false",
      "alt_text": "A bedroom with a bed, nightstand, and a wall decal.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/ModelUnit-27.jpg"
    },
    {
      "id": "ec_e9d2c94299a66ec12ff94460",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-234f-7494-b231-f4baa65b701f.webp",
      "image_media": {
        "alt_text": "Double vanity with granite countertops and a large mirror reflecting a bedroom.",
        "public_id": "01a1583b-234f-7494-b231-f4baa65b701f",
        "storage_key": "property/6767906449167570/01a1583b-234f-7494-b231-f4baa65b701f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Spacious bathroom featuring a double vanity with granite countertops, a large mirror, and a separate shower.",
      "link": "false",
      "alt_text": "A bathroom with a large mirror, a sink with a marble countertop, a toilet, and a glass shower door.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/ModelUnit-19.jpg"
    },
    {
      "id": "ec_0217f216c9b5302e8c5a1f56",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-4023-77a5-8f84-034d3d5f656f.webp",
      "image_media": {
        "alt_text": "Laundry room with washing machine and dryer.",
        "public_id": "01a1583b-4023-77a5-8f84-034d3d5f656f",
        "storage_key": "property/6767906449167570/01a1583b-4023-77a5-8f84-034d3d5f656f.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "In-unit laundry room featuring a washing machine and dryer, perfect for convenience.",
      "link": "false",
      "alt_text": "Two washing machines in a laundry room with a sign that says \"Laundry\" on the wall.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/ModelUnit-30.jpg"
    },
    {
      "id": "ec_c710cafef4e9ac7578a2563c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-45bf-7352-8889-2e8a59f3bad1.webp",
      "image_media": {
        "alt_text": "Backyard view of townhomes with fenced yards and green space.",
        "public_id": "01a1583b-45bf-7352-8889-2e8a59f3bad1",
        "storage_key": "property/6767906449167570/01a1583b-45bf-7352-8889-2e8a59f3bad1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Private fenced backyards offer a personal outdoor oasis for relaxation and recreation.",
      "link": "false",
      "alt_text": "A row of houses with a black fence in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Exterior-23.jpg"
    },
    {
      "id": "ec_545c29399a48baba3f624b85",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-4281-76c1-b5c3-7d478efa64c0.webp",
      "image_media": {
        "alt_text": "Empty apartment garage with automatic opener and water heater.",
        "public_id": "01a1583b-4281-76c1-b5c3-7d478efa64c0",
        "storage_key": "property/6767906449167570/01a1583b-4281-76c1-b5c3-7d478efa64c0.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Spacious and clean apartment garage featuring an automatic opener and a water heater, ready for your vehicle.",
      "link": "false",
      "alt_text": "A spacious garage with a door and a wall-mounted shelf.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/ModelUnit-32.jpg"
    },
    {
      "id": "ec_5807e046e549be7519ec0f50",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-4fe0-7728-a227-242ab6dd0c70.webp",
      "image_media": {
        "alt_text": "Swimming pool and clubhouse at a multifamily property on a sunny day.",
        "public_id": "01a1583b-4fe0-7728-a227-242ab6dd0c70",
        "storage_key": "property/6767906449167570/01a1583b-4fe0-7728-a227-242ab6dd0c70.webp",
        "width": 3072,
        "height": 2032
      },
      "title": "Community",
      "description": "Enjoy a refreshing swim in our sparkling pool, surrounded by comfortable lounge chairs and lush landscaping. The adjacent clubhouse offers additional amenities for relaxation and socializing.",
      "link": "false",
      "alt_text": "A black house with a pool in front.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Pool-3.jpg"
    },
    {
      "id": "ec_d2923c4ea247b3c092f2baba",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-559f-76de-bef4-d31708604139.webp",
      "image_media": {
        "alt_text": null,
        "public_id": "01a1583b-559f-76de-bef4-d31708604139",
        "storage_key": "property/6767906449167570/01a1583b-559f-76de-bef4-d31708604139.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "false",
      "description": "false",
      "link": "false",
      "alt_text": "A pool with sun loungers and a wooden pergola.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Pool-13.jpg"
    },
    {
      "id": "ec_2dc1286f5f7b5f0c154e455e",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-6b90-726e-a68d-84c6fc415472.webp",
      "image_media": {
        "alt_text": "Outdoor pickleball and tennis courts with fencing and landscaping at apartment complex.",
        "public_id": "01a1583b-6b90-726e-a68d-84c6fc415472",
        "storage_key": "property/6767906449167570/01a1583b-6b90-726e-a68d-84c6fc415472.webp",
        "width": 3072,
        "height": 2041
      },
      "title": "Community",
      "description": "Enjoy a friendly game on our outdoor pickleball and tennis courts, surrounded by lush landscaping and resort-style amenities.",
      "link": "false",
      "alt_text": "A tennis court with a blue surface and white lines is surrounded by a fence and trees.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Pool-29.jpg"
    },
    {
      "id": "ec_478523957dbf8904edd1e00a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-6b98-705e-a60b-ce370e733243.webp",
      "image_media": {
        "alt_text": "Outdoor pickleball court with blue and green surface, surrounded by fencing and landscaping.",
        "public_id": "01a1583b-6b98-705e-a60b-ce370e733243",
        "storage_key": "property/6767906449167570/01a1583b-6b98-705e-a60b-ce370e733243.webp",
        "width": 3072,
        "height": 2119
      },
      "title": "Community",
      "description": "Enjoy an active lifestyle on our vibrant outdoor pickleball court. Perfect for friendly matches and staying fit.",
      "link": "false",
      "alt_text": "A tennis court with a blue surface and green border.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Pool-31.jpg"
    },
    {
      "id": "ec_c24fd4a76ca7dd7ad8973197",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-8d8b-761e-8565-d865be01cd82.webp",
      "image_media": {
        "alt_text": "Dog park agility equipment with bone-shaped steps on turf with trees and building in background.",
        "public_id": "01a1583b-8d8b-761e-8565-d865be01cd82",
        "storage_key": "property/6767906449167570/01a1583b-8d8b-761e-8565-d865be01cd82.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our vibrant community dog park featuring agility equipment for your furry friends, surrounded by lush landscaping and modern buildings.",
      "link": "false",
      "alt_text": "A playground with a slide and a green lawn.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Exteriors-38.jpg"
    },
    {
      "id": "ec_4d17bfef9033352dee227f5c",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-97b8-76af-8859-97ca2ddd7300.webp",
      "image_media": {
        "alt_text": "Apartment complex outdoor dog park with green turf, benches, and trees.",
        "public_id": "01a1583b-97b8-76af-8859-97ca2ddd7300",
        "storage_key": "property/6767906449167570/01a1583b-97b8-76af-8859-97ca2ddd7300.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy our spacious outdoor dog park, complete with lush green turf, comfortable benches, and convenient waste disposal stations. A perfect spot for your furry friends to play and socialize.",
      "link": "false",
      "alt_text": "A green lawn in front of a row of houses.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Exteriors-31.jpg"
    },
    {
      "id": "ec_cb95df33c1aea146ddedfb47",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-a248-7446-b9af-538b8a627a2a.webp",
      "image_media": {
        "alt_text": "Community lounge area with bar and seating.",
        "public_id": "01a1583b-a248-7446-b9af-538b8a627a2a",
        "storage_key": "property/6767906449167570/01a1583b-a248-7446-b9af-538b8a627a2a.webp",
        "width": 3072,
        "height": 2204
      },
      "title": "Community",
      "description": "Relax and socialize in our stylish community lounge. Enjoy a coffee or chat with neighbors at the modern bar area, complete with comfortable seating and elegant decor.",
      "link": "false",
      "alt_text": "A dining room with a table and chairs.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Clubhouse-4.jpg"
    },
    {
      "id": "ec_41cb4303a1bd19391f934d91",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-aa6d-703c-8916-0974dee7acd5.webp",
      "image_media": {
        "alt_text": "A stylish living room with a beige sofa, blue armchair, and a white coffee table.",
        "public_id": "01a1583b-aa6d-703c-8916-0974dee7acd5",
        "storage_key": "property/6767906449167570/01a1583b-aa6d-703c-8916-0974dee7acd5.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Apartment",
      "description": "Step into comfort and style in this beautifully appointed living room, featuring plush seating and elegant decor.",
      "link": "false",
      "alt_text": "A living room with a couch, a chair, a table, and a lamp.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Clubhouse-5.jpg"
    },
    {
      "id": "ec_bb608d997530b40c2152db0b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-d503-741a-8f2a-1aa39a0487ac.webp",
      "image_media": {
        "alt_text": "Covered outdoor patio area with seating and tables overlooking residential buildings.",
        "public_id": "01a1583b-d503-741a-8f2a-1aa39a0487ac",
        "storage_key": "property/6767906449167570/01a1583b-d503-741a-8f2a-1aa39a0487ac.webp",
        "width": 3072,
        "height": 1925
      },
      "title": "Community",
      "description": "Enjoy outdoor living on the spacious covered patio, perfect for relaxing or entertaining with comfortable seating and dining areas.",
      "link": "false",
      "alt_text": "A patio with a white couch and a table with a bottle on it.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Clubhouse-8.jpg"
    },
    {
      "id": "ec_d7927aad889066a27eeb77f5",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-e0ba-728e-9164-32167f8042ca.webp",
      "image_media": {
        "alt_text": "Outdoor lounge area with modern furniture, brick accent wall, and stylish lighting.",
        "public_id": "01a1583b-e0ba-728e-9164-32167f8042ca",
        "storage_key": "property/6767906449167570/01a1583b-e0ba-728e-9164-32167f8042ca.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Relax and socialize in our beautifully appointed outdoor lounge, featuring comfortable seating, ambient lighting, and a stylish brick accent wall. Perfect for unwinding or entertaining guests.",
      "link": "false",
      "alt_text": "A modern living room with a stone wall and a variety of seating options.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Pool-20.jpg"
    },
    {
      "id": "ec_0678a5d9903512e9ede2fff6",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-dce4-733a-922e-0a2d4d27841b.webp",
      "image_media": {
        "alt_text": "Exterior view of colorful townhomes with green lawns and a blue sky.",
        "public_id": "01a1583b-dce4-733a-922e-0a2d4d27841b",
        "storage_key": "property/6767906449167570/01a1583b-dce4-733a-922e-0a2d4d27841b.webp",
        "width": 3072,
        "height": 2057
      },
      "title": "Community",
      "description": "Modern townhomes with colorful facades, manicured lawns, and a bright blue sky. Welcome to your new home!",
      "link": "false",
      "alt_text": "A row of houses with different colored fronts.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Exterior-14%20(1).jpg"
    },
    {
      "id": "ec_ba4a97ae0343bc33c6af4ddb",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583b-e49a-72ea-81cd-3c3ea757001b.webp",
      "image_media": {
        "alt_text": "Exterior view of a row of townhomes with colorful facades and manicured lawns.",
        "public_id": "01a1583b-e49a-72ea-81cd-3c3ea757001b",
        "storage_key": "property/6767906449167570/01a1583b-e49a-72ea-81cd-3c3ea757001b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Discover comfortable living in these charming townhomes, featuring vibrant exteriors and beautifully landscaped grounds.",
      "link": "false",
      "alt_text": "A row of houses with different colors.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Exteriors-26.jpg"
    },
    {
      "id": "ec_5ce3ed061b6546465bf2708d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583c-0129-745b-937f-1e10d1006020.webp",
      "image_media": {
        "alt_text": "Row of colorful townhomes with garages and manicured lawns on a sunny day.",
        "public_id": "01a1583c-0129-745b-937f-1e10d1006020",
        "storage_key": "property/6767906449167570/01a1583c-0129-745b-937f-1e10d1006020.webp",
        "width": 3072,
        "height": 1983
      },
      "title": "Community",
      "description": "Discover vibrant living in these beautifully designed townhomes, featuring attached garages and lush green spaces.",
      "link": "false",
      "alt_text": "A row of houses with a white house on the left and a red house on the right.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Exterior-12.jpg"
    },
    {
      "id": "ec_8fa4ba68d8e69a6ee3c3a42a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a1583c-1475-75ba-948e-aba1dbf29074.webp",
      "image_media": {
        "alt_text": "Mailboxes at apartment complex.",
        "public_id": "01a1583c-1475-75ba-948e-aba1dbf29074",
        "storage_key": "property/6767906449167570/01a1583c-1475-75ba-948e-aba1dbf29074.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Secure mailboxes for residents of the apartment community.",
      "link": "false",
      "alt_text": "A row of black mailboxes are lined up on a sidewalk.",
      "link_text": "false",
      "source_page_urls": "false",
      "original_url": "https://cdn.rentcafe.com/dmslivecafe/2/137392/Exterior-3.jpg"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_e7e953d5-e79a-4e15-b49e-d012e9b0ed79",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Avocados Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "109 Bradford St NE SE, Gainesville, GA 30501, USA",
      "poi_short_description": "Down-home venue with a bar & sidewalk tables serving breakfast, sandwiches, burgers, pasta & more.",
      "poi_long_description": "Down-home venue with a bar & sidewalk tables serving breakfast, sandwiches, burgers, pasta & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-942f-755b-b860-744e1a2d66df.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-942f-755b-b860-744e1a2d66df",
        "storage_key": "property/6767906449167570/019fa9a9-942f-755b-b860-744e1a2d66df.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.avocadoseats.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8381229742925225207&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "avocados-restaurant",
      "poi_latitude": "34.2995277",
      "poi_longitude": "-83.8265543",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-532-0001",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26bc-7232-a6d9-d392edc446ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26bc-7232-a6d9-d392edc446ee",
        "storage_key": "property/6767906449167570/019fa9a6-26bc-7232-a6d9-d392edc446ee.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJUTRaMY329YgR9xz_pwscUHQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_5d40d333-9c4f-4e97-9ff5-19e55f3050ac",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Meadowlark Coffee",
      "poi_type": "Restaurants",
      "poi_address": "109 Bradford St NE, Gainesville, GA 30501, USA",
      "poi_short_description": "Coffee shop dispensing espresso drinks, tea, and pastries in a laid-back setting with limited seating.",
      "poi_long_description": "Coffee shop dispensing espresso drinks, tea, and pastries in a laid-back setting with limited seating.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-93f4-756c-9cad-6e535d5025ab.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-93f4-756c-9cad-6e535d5025ab",
        "storage_key": "property/6767906449167570/019fa9a9-93f4-756c-9cad-6e535d5025ab.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://meadowlarkcoffee.shop/",
      "poi_directions_map_url": "https://maps.google.com/?cid=235339761201357934&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "meadowlark-coffee",
      "poi_latitude": "34.3000105",
      "poi_longitude": "-83.82712839999999",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 470-892-6719",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-eb1d-72ef-8d0f-142b5fb918ce.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a9-eb1d-72ef-8d0f-142b5fb918ce",
        "storage_key": "property/6767906449167570/019fa9a9-eb1d-72ef-8d0f-142b5fb918ce.webp",
        "width": 192,
        "height": 144
      },
      "poi_google_place_id": "ChIJ0WKglvT39YgRbqTuE0QYRAM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "coffee_shop"
    },
    {
      "id": "custom_dcfd201b-31ab-498a-afc8-70210348533e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "YellowFin",
      "poi_type": "Restaurants",
      "poi_address": "120 Bradford St NE, Gainesville, GA 30501, USA",
      "poi_short_description": "Seafood, steaks & cocktails served in a warm, laid-back restaurant with exposed-brick walls.",
      "poi_long_description": "Seafood, steaks & cocktails served in a warm, laid-back restaurant with exposed-brick walls.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-9dfd-751b-9eed-7a7780db91e8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-9dfd-751b-9eed-7a7780db91e8",
        "storage_key": "property/6767906449167570/019fa9a9-9dfd-751b-9eed-7a7780db91e8.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=14838566536699469442&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "yellowfin",
      "poi_latitude": "34.3004334",
      "poi_longitude": "-83.8270014",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 678-450-4225",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26bc-7232-a6d9-d392edc446ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26bc-7232-a6d9-d392edc446ee",
        "storage_key": "property/6767906449167570/019fa9a6-26bc-7232-a6d9-d392edc446ee.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ34graO329YgRgl74o6Ut7c0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "seafood_restaurant"
    },
    {
      "id": "custom_f5052128-9a09-402b-9ea1-22af4beb0ff3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "The Stag - Chophouse",
      "poi_type": "Restaurants",
      "poi_address": "110 Main St SW, Gainesville, GA 30501, USA",
      "poi_short_description": "Casual chophouse serving steaks, chops, and seafood, plus handcrafted cocktails.",
      "poi_long_description": "Casual chophouse serving steaks, chops, and seafood, plus handcrafted cocktails.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-9e4d-737a-945f-11f93b08de9a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-9e4d-737a-945f-11f93b08de9a",
        "storage_key": "property/6767906449167570/019fa9a9-9e4d-737a-945f-11f93b08de9a.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://thestagchophouse.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8145278527156208522&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-stag---chophouse",
      "poi_latitude": "34.2990403",
      "poi_longitude": "-83.8274575",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 470-252-5016",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26bc-7232-a6d9-d392edc446ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26bc-7232-a6d9-d392edc446ee",
        "storage_key": "property/6767906449167570/019fa9a6-26bc-7232-a6d9-d392edc446ee.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJVTmIWMz39YgRikPDN6rXCXE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_c1928d46-3abf-48eb-9561-5b9e5296f607",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Luna's Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "200 Main St SW Ste 102, Gainesville, GA 30501, USA",
      "poi_short_description": "American fare served in white-napkin, low-key setting, with live music in piano lounge on weekends.",
      "poi_long_description": "American fare served in white-napkin, low-key setting, with live music in piano lounge on weekends.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-994b-719c-8064-ef2e595651d7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-994b-719c-8064-ef2e595651d7",
        "storage_key": "property/6767906449167570/019fa9a9-994b-719c-8064-ef2e595651d7.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.lunas.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1511809139862528254&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lunas-restaurant",
      "poi_latitude": "34.2984536",
      "poi_longitude": "-83.8273315",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-531-0848",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26bc-7232-a6d9-d392edc446ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26bc-7232-a6d9-d392edc446ee",
        "storage_key": "property/6767906449167570/019fa9a6-26bc-7232-a6d9-d392edc446ee.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6_SoRI329YgR_uCxHWcG-xQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fine_dining_restaurant"
    },
    {
      "id": "custom_c3bcfd31-57bb-4d3f-a2ef-f38b11c02a5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Atlas Pizza",
      "poi_type": "Restaurants",
      "poi_address": "104 Washington St NW, Gainesville, GA 30501, USA",
      "poi_short_description": "Specialty pies, subs, wings, wraps & beer served in a no-frills cafe space with a pool table.",
      "poi_long_description": "Specialty pies, subs, wings, wraps & beer served in a no-frills cafe space with a pool table.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-9696-769f-90c8-b9c0f0fdd6fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-9696-769f-90c8-b9c0f0fdd6fc",
        "storage_key": "property/6767906449167570/019fa9a9-9696-769f-90c8-b9c0f0fdd6fc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.atlaspizza.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7859935713741094784&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "atlas-pizza",
      "poi_latitude": "34.2998258",
      "poi_longitude": "-83.82720979999999",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 15 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-531-1144",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26bc-7232-a6d9-d392edc446ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26bc-7232-a6d9-d392edc446ee",
        "storage_key": "property/6767906449167570/019fa9a6-26bc-7232-a6d9-d392edc446ee.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJkXyPO4329YgRgL_xTuMZFG0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pizza_restaurant"
    },
    {
      "id": "custom_8cfad76c-4ba5-4964-9bba-8f0fbb977bbc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "El Patron Family Mexican Restaurant Gainesville",
      "poi_type": "Restaurants",
      "poi_address": "250 John W Morrow Jr Pkwy #104, Gainesville, GA 30501, USA",
      "poi_short_description": "Mexican cuisine, including fajitas and margaritas, in a cozy space with a kids' menu.",
      "poi_long_description": "Mexican cuisine, including fajitas and margaritas, in a cozy space with a kids' menu.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-9a08-712f-b838-27862c31466e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-9a08-712f-b838-27862c31466e",
        "storage_key": "property/6767906449167570/019fa9a9-9a08-712f-b838-27862c31466e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://elpatronmexicanrestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12327222328183541892&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "el-patron-family-mexican-restaurant-gainesville",
      "poi_latitude": "34.2956145",
      "poi_longitude": "-83.83954489999999",
      "poi_miles_from_property": "4.0 mi",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 909-757-1323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26bc-7232-a6d9-d392edc446ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26bc-7232-a6d9-d392edc446ee",
        "storage_key": "property/6767906449167570/019fa9a6-26bc-7232-a6d9-d392edc446ee.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmyiXexf39YgRhNCkImUXE6s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_eeffaf56-b887-4233-a745-8637014c61e0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Alpha Gyro Grill",
      "poi_type": "Restaurants",
      "poi_address": "215 Jesse Jewell Pkwy SE, Gainesville, GA 30501, USA",
      "poi_short_description": "Modest counter-service cafe & bakery offering classic Greek sandwiches, skewers & salads.",
      "poi_long_description": "Modest counter-service cafe & bakery offering classic Greek sandwiches, skewers & salads.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-a1fb-710c-9247-76f9c5177a8c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-a1fb-710c-9247-76f9c5177a8c",
        "storage_key": "property/6767906449167570/019fa9a9-a1fb-710c-9247-76f9c5177a8c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://agyrogrill.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=18174482716824138656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alpha-gyro-grill",
      "poi_latitude": "34.2984356",
      "poi_longitude": "-83.8238121",
      "poi_miles_from_property": "3.0 mi",
      "poi_walking_minutes": "1 hour 10 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 678-696-8380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26bc-7232-a6d9-d392edc446ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26bc-7232-a6d9-d392edc446ee",
        "storage_key": "property/6767906449167570/019fa9a6-26bc-7232-a6d9-d392edc446ee.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJmTpGj_L29YgRoHPHCL27OPw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "greek_restaurant"
    },
    {
      "id": "custom_7e89ee30-1b9f-4fbf-9c3f-3d62371773c7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Decoy",
      "poi_type": "Restaurants",
      "poi_address": "123 Green St NE, Gainesville, GA 30501, USA",
      "poi_short_description": "Family-friendly restaurant and bar with a menu of elevated takes on familiar dishes.",
      "poi_long_description": "Family-friendly restaurant and bar with a menu of elevated takes on familiar dishes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-a575-745d-a85b-4a9a159cf766.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-a575-745d-a85b-4a9a159cf766",
        "storage_key": "property/6767906449167570/019fa9a9-a575-745d-a85b-4a9a159cf766.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.eatplaydecoy.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18068627310805926818&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "decoy",
      "poi_latitude": "34.300709",
      "poi_longitude": "-83.8266271",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 16 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 678-943-1371",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26bc-7232-a6d9-d392edc446ee.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26bc-7232-a6d9-d392edc446ee",
        "storage_key": "property/6767906449167570/019fa9a6-26bc-7232-a6d9-d392edc446ee.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJzV31lLD39YgRokOCt86owPo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_1dc07172-1e31-4271-b99e-4538310edd60",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Kroger Marketplace",
      "poi_type": "Shopping & Retail",
      "poi_address": "1931 Jesse Jewell Pkwy SE, Gainesville, GA 30501, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a5-c6dd-75bd-bacd-5db67d544828.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a5-c6dd-75bd-bacd-5db67d544828",
        "storage_key": "property/6767906449167570/019fa9a5-c6dd-75bd-bacd-5db67d544828.webp",
        "width": 1280,
        "height": 857
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/ga/gainesville/new-holland-market/011/00682?cid=loc_01100682_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=14249891361474847113&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger-marketplace",
      "poi_latitude": "34.315316",
      "poi_longitude": "-83.79817000000001",
      "poi_miles_from_property": "1.2 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 470-252-3182",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26d1-739f-81a8-d471dc323f0c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26d1-739f-81a8-d471dc323f0c",
        "storage_key": "property/6767906449167570/019fa9a6-26d1-739f-81a8-d471dc323f0c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt6KDjqn39YgRiaGdsLHIwcU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_3f421eaf-1f52-41de-8bd1-f01b3d834345",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "QuikTrip",
      "poi_type": "Transportation & Transit",
      "poi_address": "1910 Jesse Jewell Pkwy NE, Gainesville, GA 30501, USA",
      "poi_short_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_long_description": "Convenience store chain supplying snacks, sandwiches & fountain drinks, plus gasoline.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-a6e1-7318-add8-79fee0b6b587.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-a6e1-7318-add8-79fee0b6b587",
        "storage_key": "property/6767906449167570/019fa9a9-a6e1-7318-add8-79fee0b6b587.webp",
        "width": 600,
        "height": 339
      },
      "poi_business_url": "https://locations.quiktrip.com/ga/gainesville/1910-jesse-jewell-pkwy-ne?utm_source=gmb&utm_medium=yext&y_source=1_MTYwMDQzMzAtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=1595780562117305941&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quiktrip",
      "poi_latitude": "34.3123245",
      "poi_longitude": "-83.7957131",
      "poi_miles_from_property": "1.1 mi",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 770-287-1607",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-eafb-751f-b6a0-d6c1d4f3d01a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a9-eafb-751f-b6a0-d6c1d4f3d01a",
        "storage_key": "property/6767906449167570/019fa9a9-eafb-751f-b6a0-d6c1d4f3d01a.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJe1Wx2qj39YgRVaZ5aPdZJRY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gas_station"
    },
    {
      "id": "custom_7307700b-52be-4672-806a-0975ad5b6ee9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Walgreens",
      "poi_type": "Health and Wellness",
      "poi_address": "472 S Enota Dr NE, Gainesville, GA 30501, USA",
      "poi_short_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_long_description": "Drugstore chain with health & beauty aids, prescriptions & photo services, plus mini-mart basics.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-a94f-7459-9a61-4df7a7a7f89d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-a94f-7459-9a61-4df7a7a7f89d",
        "storage_key": "property/6767906449167570/019fa9a9-a94f-7459-9a61-4df7a7a7f89d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-472+s+enota+dr+ne-gainesville-ga-30501/id=9706",
      "poi_directions_map_url": "https://maps.google.com/?cid=4158874725475654112&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens",
      "poi_latitude": "34.3093855",
      "poi_longitude": "-83.81495269999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "54 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-535-3750",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26ec-73e2-8938-3b8579245c34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26ec-73e2-8938-3b8579245c34",
        "storage_key": "property/6767906449167570/019fa9a6-26ec-73e2-8938-3b8579245c34.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo2OY81f29YgR4JlTNYdKtzk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "drugstore"
    },
    {
      "id": "custom_006f56f0-e3d5-4fd5-89d4-22076b36c64d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Walmart Supercenter",
      "poi_type": "Shopping & Retail",
      "poi_address": "400 Shallowford Rd, Gainesville, GA 30504, USA",
      "poi_short_description": "Department store chain offering a broad array of items, including apparel, electronics, and housewares.",
      "poi_long_description": "Department store chain offering a broad array of items, including apparel, electronics, and housewares.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-a964-71f4-ba81-14c0bba18dbb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-a964-71f4-ba81-14c0bba18dbb",
        "storage_key": "property/6767906449167570/019fa9a9-a964-71f4-ba81-14c0bba18dbb.webp",
        "width": 1067,
        "height": 600
      },
      "poi_business_url": "https://www.walmart.com/store/510-gainesville-ga/?veh=seo_loc",
      "poi_directions_map_url": "https://maps.google.com/?cid=8550683598455917285&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walmart-supercenter",
      "poi_latitude": "34.2918903",
      "poi_longitude": "-83.8504476",
      "poi_miles_from_property": "4.9 mi",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 770-503-9300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26e4-74e8-8f63-6db34234472a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26e4-74e8-8f63-6db34234472a",
        "storage_key": "property/6767906449167570/019fa9a6-26e4-74e8-8f63-6db34234472a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJHxxBqCD09YgR5Uq56G0hqnY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_7d5b80fe-1704-4c90-8c7b-aef18ca5cba9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Publix Super Market at Village Shoppes of Gainesville",
      "poi_type": "Shopping & Retail",
      "poi_address": "879 Dawsonville Hwy, Gainesville, GA 30501, USA",
      "poi_short_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_long_description": "Supermarket chain with a wide selection of groceries, plus deli & bakery departments.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-ac14-7705-aad0-b3ea071ad4aa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-ac14-7705-aad0-b3ea071ad4aa",
        "storage_key": "property/6767906449167570/019fa9a9-ac14-7705-aad0-b3ea071ad4aa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.publix.com/?setstorenumber=1110&utm_medium=maps&utm_source=extendednetwork&utm_content=psm_website_url",
      "poi_directions_map_url": "https://maps.google.com/?cid=6174682105009126027&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "publix-super-market-at-village-shoppes-of-gainesville",
      "poi_latitude": "34.2966166",
      "poi_longitude": "-83.85963989999999",
      "poi_miles_from_property": "5.6 mi",
      "poi_walking_minutes": "2 hours 7 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 770-534-1350",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26d1-739f-81a8-d471dc323f0c.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26d1-739f-81a8-d471dc323f0c",
        "storage_key": "property/6767906449167570/019fa9a6-26d1-739f-81a8-d471dc323f0c.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJs253JST09YgRi7oH3qjgsFU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "supermarket"
    },
    {
      "id": "custom_c2ea1445-4746-49db-b630-cf11da68de47",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Sandra Dunagan Deal Elementary School",
      "poi_type": "Education",
      "poi_address": "2850 Ramsey Rd, Gainesville, GA 30501, USA",
      "poi_short_description": "Public elementary school, Hall County School District.",
      "poi_long_description": "Public elementary school, Hall County School District.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://des.hallco.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8128085672491218804&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sandra-dunagan-deal-elementary-school",
      "poi_latitude": "34.3444747",
      "poi_longitude": "-83.7768215",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 470-892-3250",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26c0-7056-9732-43a6c2dc4e03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26c0-7056-9732-43a6c2dc4e03",
        "storage_key": "property/6767906449167570/019fa9a6-26c0-7056-9732-43a6c2dc4e03.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJx-npPAD39YgRdPfHzNrCzHA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_c08ff3a5-1892-44df-a2e7-9891168b4f68",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "East Hall Middle School",
      "poi_type": "Education",
      "poi_address": "4120 E Hall Rd, Gainesville, GA 30507, USA",
      "poi_short_description": "Public middle school, Hall County School District.",
      "poi_long_description": "Public middle school, Hall County School District.",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://ehms.hallco.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16016299217637655197&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-hall-middle-school",
      "poi_latitude": "34.30781169999999",
      "poi_longitude": "-83.741455",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-531-9457",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26c0-7056-9732-43a6c2dc4e03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26c0-7056-9732-43a6c2dc4e03",
        "storage_key": "property/6767906449167570/019fa9a6-26c0-7056-9732-43a6c2dc4e03.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJzTbXckr49YgRncKoy0dTRd4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_4c650dcb-dc8b-4e36-bd69-8b437b98c02e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "East Hall High School",
      "poi_type": "Education",
      "poi_address": "3534 E Hall Rd, Gainesville, GA 30507, USA",
      "poi_short_description": "Public high school, Hall County School District.",
      "poi_long_description": "Public high school, Hall County School District.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-ae5b-777b-b275-eac762c5d6b5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-ae5b-777b-b275-eac762c5d6b5",
        "storage_key": "property/6767906449167570/019fa9a9-ae5b-777b-b275-eac762c5d6b5.webp",
        "width": 1240,
        "height": 827
      },
      "poi_business_url": "https://ehhs.hallco.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16990304267194247356&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "east-hall-high-school",
      "poi_latitude": "34.334393",
      "poi_longitude": "-83.741936",
      "poi_miles_from_property": "4.8 mi",
      "poi_walking_minutes": "1 hour 47 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-536-9921",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26c0-7056-9732-43a6c2dc4e03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26c0-7056-9732-43a6c2dc4e03",
        "storage_key": "property/6767906449167570/019fa9a6-26c0-7056-9732-43a6c2dc4e03.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJk9dnEBP49YgRvKjqZ7avyes",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_80128a0b-82f6-4a32-be6f-81203d1ee9a9",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Gainesville High School",
      "poi_type": "Education",
      "poi_address": "830 Century Pl, Gainesville, GA 30501, USA",
      "poi_short_description": "Public high school, Gainesville City School System.",
      "poi_long_description": "Public high school, Gainesville City School System.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-af2d-7529-864d-0d206b2617b4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-af2d-7529-864d-0d206b2617b4",
        "storage_key": "property/6767906449167570/019fa9a9-af2d-7529-864d-0d206b2617b4.webp",
        "width": 851,
        "height": 480
      },
      "poi_business_url": "http://gcssk12.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9154025908307649252&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gainesville-high-school",
      "poi_latitude": "34.3001169",
      "poi_longitude": "-83.84498599999999",
      "poi_miles_from_property": "4.5 mi",
      "poi_walking_minutes": "1 hour 42 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 470-252-6353",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26c0-7056-9732-43a6c2dc4e03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26c0-7056-9732-43a6c2dc4e03",
        "storage_key": "property/6767906449167570/019fa9a6-26c0-7056-9732-43a6c2dc4e03.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ_x9B5IL29YgR5GJmQRCiCX8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_0983d2d1-ca20-4064-952b-a094ecdca552",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Gainesville Middle School East Campus",
      "poi_type": "Education",
      "poi_address": "1581 Community Way, Gainesville, GA 30501, USA",
      "poi_short_description": "Public middle school, Gainesville City School System.",
      "poi_long_description": "Public middle school, Gainesville City School System.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-b1a3-7279-89c7-79890c43625e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-b1a3-7279-89c7-79890c43625e",
        "storage_key": "property/6767906449167570/019fa9a9-b1a3-7279-89c7-79890c43625e.webp",
        "width": 851,
        "height": 480
      },
      "poi_business_url": "https://gmsweb.gcssk12.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6628819400238209831&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gainesville-middle-school-east-campus",
      "poi_latitude": "34.3111567",
      "poi_longitude": "-83.80669189999999",
      "poi_miles_from_property": "1.9 mi",
      "poi_walking_minutes": "45 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 770-534-4237",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26c0-7056-9732-43a6c2dc4e03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26c0-7056-9732-43a6c2dc4e03",
        "storage_key": "property/6767906449167570/019fa9a6-26c0-7056-9732-43a6c2dc4e03.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJmX-eJ3fy9YgRJ5tqnx9M_ls",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_3e96c3eb-929d-41aa-86b3-f67730c9cd61",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Brenau University",
      "poi_type": "Education",
      "poi_address": "500 Washington St SE, Gainesville, GA 30501, USA",
      "poi_short_description": "Private university with its historic main campus in Gainesville.",
      "poi_long_description": "Private university with its historic main campus in Gainesville.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a5-dc74-7177-b6d9-f776d2dab0c7.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a5-dc74-7177-b6d9-f776d2dab0c7",
        "storage_key": "property/6767906449167570/019fa9a5-dc74-7177-b6d9-f776d2dab0c7.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://www.brenau.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6344588805973639156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "brenau-university",
      "poi_latitude": "34.3041802",
      "poi_longitude": "-83.8201186",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-534-6299",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26c0-7056-9732-43a6c2dc4e03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26c0-7056-9732-43a6c2dc4e03",
        "storage_key": "property/6767906449167570/019fa9a6-26c0-7056-9732-43a6c2dc4e03.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJqQu-v_b29YgR9H_6aeeBDFg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_72bf3e3f-c4a8-4650-8c3f-e7f4d0992257",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Lakeview Academy",
      "poi_type": "Education",
      "poi_address": "796 Lakeview Dr, Gainesville, GA 30501, USA",
      "poi_short_description": "Private, independent PK-12 school in Gainesville.",
      "poi_long_description": "Private, independent PK-12 school in Gainesville.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-b4c6-73f5-9643-f3d085619c10.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-b4c6-73f5-9643-f3d085619c10",
        "storage_key": "property/6767906449167570/019fa9a9-b4c6-73f5-9643-f3d085619c10.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.lakeviewacademy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3873559903981222838&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lakeview-academy",
      "poi_latitude": "34.3210918",
      "poi_longitude": "-83.806609",
      "poi_miles_from_property": "1.5 mi",
      "poi_walking_minutes": "34 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 770-532-4383",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26c0-7056-9732-43a6c2dc4e03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26c0-7056-9732-43a6c2dc4e03",
        "storage_key": "property/6767906449167570/019fa9a6-26c0-7056-9732-43a6c2dc4e03.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJX1m3EE329YgRtjv_rDWmwTU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_ba7a1de4-ac9f-40c6-a863-c1660b455b17",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Lanier Technical College",
      "poi_type": "Education",
      "poi_address": "2535 Lanier Tech Dr, Gainesville, GA 30507, USA",
      "poi_short_description": "Public technical college, part of the Technical College System of Georgia.",
      "poi_long_description": "Public technical college, part of the Technical College System of Georgia.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-b457-7139-952e-f3615790783c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-b457-7139-952e-f3615790783c",
        "storage_key": "property/6767906449167570/019fa9a9-b457-7139-952e-f3615790783c.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.laniertech.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15389954272158432829&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lanier-technical-college",
      "poi_latitude": "34.3308868",
      "poi_longitude": "-83.7782821",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 770-533-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26c0-7056-9732-43a6c2dc4e03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26c0-7056-9732-43a6c2dc4e03",
        "storage_key": "property/6767906449167570/019fa9a6-26c0-7056-9732-43a6c2dc4e03.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ4Z5WHsjz9YgRPT6C_d4ZlNU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "educational_institution"
    },
    {
      "id": "custom_3de74d55-9041-4b6c-b551-4ddeef65689e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Quinlan Visual Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "514 Green St, Gainesville, GA 30501, USA",
      "poi_short_description": "Visual arts center offering exhibitions, classes for children and adults, and a gift shop.",
      "poi_long_description": "Visual arts center offering exhibitions, classes for children and adults, and a gift shop.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-b4c9-76f9-8607-e90caad5e819.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-b4c9-76f9-8607-e90caad5e819",
        "storage_key": "property/6767906449167570/019fa9a9-b4c9-76f9-8607-e90caad5e819.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "http://www.quinlanartscenter.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6514758892553398499&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "quinlan-visual-arts-center",
      "poi_latitude": "34.307305",
      "poi_longitude": "-83.82588270000001",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-536-2575",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26ec-73e2-8938-3b8579245c34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26ec-73e2-8938-3b8579245c34",
        "storage_key": "property/6767906449167570/019fa9a6-26ec-73e2-8938-3b8579245c34.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJF7PLNfX29YgR42j2M7ISaVo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_4a26ede3-67fd-4e31-a564-7e25b84db97a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Northeast Georgia History Center",
      "poi_type": "Entertainment",
      "poi_address": "322 Academy St NE, Gainesville, GA 30501, USA",
      "poi_short_description": "Museum featuring exhibits on regional culture & history, plus a shop with books & local crafts.",
      "poi_long_description": "Museum featuring exhibits on regional culture & history, plus a shop with books & local crafts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a5-e03d-7105-bc58-6a7a62ab6e0f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a5-e03d-7105-bc58-6a7a62ab6e0f",
        "storage_key": "property/6767906449167570/019fa9a5-e03d-7105-bc58-6a7a62ab6e0f.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://www.negahc.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7491700726147654901&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northeast-georgia-history-center",
      "poi_latitude": "34.3024578",
      "poi_longitude": "-83.82487890000002",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-297-5900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26f2-73e2-aedd-a8fb8feb1ffc.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26f2-73e2-aedd-a8fb8feb1ffc",
        "storage_key": "property/6767906449167570/019fa9a6-26f2-73e2-aedd-a8fb8feb1ffc.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJB1ZmW_P29YgR9SSRIR7e92c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "history_museum"
    },
    {
      "id": "custom_fd0e4a92-548f-426d-b3c4-cc953381b129",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Smithgall Arts Center",
      "poi_type": "Entertainment",
      "poi_address": "331 Spring St SW, Gainesville, GA 30501, USA",
      "poi_short_description": "Downtown arts venue run by The Arts Council, hosting concerts, exhibitions and classes.",
      "poi_long_description": "Downtown arts venue run by The Arts Council, hosting concerts, exhibitions and classes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-b6a8-77fc-8546-137c66188c13.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-b6a8-77fc-8546-137c66188c13",
        "storage_key": "property/6767906449167570/019fa9a9-b6a8-77fc-8546-137c66188c13.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://theartscouncil.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17651356938652135156&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "smithgall-arts-center",
      "poi_latitude": "34.29786989999999",
      "poi_longitude": "-83.82861609999999",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-534-2787",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26ec-73e2-8938-3b8579245c34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26ec-73e2-8938-3b8579245c34",
        "storage_key": "property/6767906449167570/019fa9a6-26ec-73e2-8938-3b8579245c34.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhcc-bGf39YgR9K78Y5039vQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "performing_arts_theater"
    },
    {
      "id": "custom_1be4b80c-f4e0-466e-b055-3242df4e0f6d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Pearce Auditorium",
      "poi_type": "Entertainment",
      "poi_address": "Pearce Auditorium, 202 Boulevard NE, Gainesville, GA 30501, USA",
      "poi_short_description": "Historical auditorium hosting performances by the Gainesville Theater Alliance, including children's plays.",
      "poi_long_description": "Historical auditorium hosting performances by the Gainesville Theater Alliance, including children's plays.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-b9ac-75ec-a434-6983dfe72b9f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-b9ac-75ec-a434-6983dfe72b9f",
        "storage_key": "property/6767906449167570/019fa9a9-b9ac-75ec-a434-6983dfe72b9f.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://gainesvilletheatrealliance.org/locations/537/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6669267034274404396&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pearce-auditorium",
      "poi_latitude": "34.3031674",
      "poi_longitude": "-83.8216151",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 7 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-534-6246",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26ec-73e2-8938-3b8579245c34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26ec-73e2-8938-3b8579245c34",
        "storage_key": "property/6767906449167570/019fa9a6-26ec-73e2-8938-3b8579245c34.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ77cr9vP29YgRLBgmSgj_jVw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "auditorium"
    },
    {
      "id": "custom_d1f827a4-7d0b-4547-bea1-720b8f1e1df8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Downtown Drafts",
      "poi_type": "Restaurants",
      "poi_address": "115 Bradford St NW, Gainesville, GA 30501, USA",
      "poi_short_description": "Casual beer hall with bar games offering growlers to go, plus mimosas and cider.",
      "poi_long_description": "Casual beer hall with bar games offering growlers to go, plus mimosas and cider.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-e444-75f5-9cd2-2df4f1bdf1c4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-e444-75f5-9cd2-2df4f1bdf1c4",
        "storage_key": "property/6767906449167570/019fa9a9-e444-75f5-9cd2-2df4f1bdf1c4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.downtowndrafts.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12016519948948323669&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "downtown-drafts",
      "poi_latitude": "34.2993316",
      "poi_longitude": "-83.82642369999999",
      "poi_miles_from_property": "3.2 mi",
      "poi_walking_minutes": "1 hour 14 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 678-943-2165",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-eadc-723e-a237-30b87a1d3fed.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a9-eadc-723e-a237-30b87a1d3fed",
        "storage_key": "property/6767906449167570/019fa9a9-eadc-723e-a237-30b87a1d3fed.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZ8E9No329YgRVb11MTpBw6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bar"
    },
    {
      "id": "custom_94b8f1dd-7e03-4174-b0b4-edd53f444506",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "The Hall at Bourbon Brothers",
      "poi_type": "Entertainment",
      "poi_address": "312 Jesse Jewell Pkwy, Gainesville, GA 30501, USA",
      "poi_short_description": "Venue hosting live music acts and offering a restaurant, plus a bar.",
      "poi_long_description": "Venue hosting live music acts and offering a restaurant, plus a bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-bb42-7023-80b0-ebf57c982022.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-bb42-7023-80b0-ebf57c982022",
        "storage_key": "property/6767906449167570/019fa9a9-bb42-7023-80b0-ebf57c982022.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.thehallga.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11514628445291339021&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-hall-at-bourbon-brothers",
      "poi_latitude": "34.297005",
      "poi_longitude": "-83.8273169",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 678-434-0475",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26ec-73e2-8938-3b8579245c34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26ec-73e2-8938-3b8579245c34",
        "storage_key": "property/6767906449167570/019fa9a6-26ec-73e2-8938-3b8579245c34.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZSN1xFX39YgRDd0yWpAtzJ8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "live_music_venue"
    },
    {
      "id": "custom_cfa315d2-77d7-4581-ae25-3fb8c454a048",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Regal Hollywood - Gainesville",
      "poi_type": "Entertainment",
      "poi_address": "120 Green Hill Cir, Gainesville, GA 30504, USA",
      "poi_short_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_long_description": "Theater complex with multiple screens featuring new release films, plush seating & concession stand.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-bdf6-7779-9544-397f90c839fa.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-bdf6-7779-9544-397f90c839fa",
        "storage_key": "property/6767906449167570/019fa9a9-bdf6-7779-9544-397f90c839fa.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.regmovies.com/theatres/regal-hollywood-cinemas-gainesville-1421?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=6485499804185912470&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "regal-hollywood---gainesville",
      "poi_latitude": "34.2953304",
      "poi_longitude": "-83.8568021",
      "poi_miles_from_property": "5.4 mi",
      "poi_walking_minutes": "2 hours 2 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 844-462-7342",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-eaf2-730b-afa2-ffc4a9f5dbb1.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a9-eaf2-730b-afa2-ffc4a9f5dbb1",
        "storage_key": "property/6767906449167570/019fa9a9-eaf2-730b-afa2-ffc4a9f5dbb1.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJGdzJbiT09YgRluRd07UfAVo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_9125dc73-cb50-4099-af21-97014d55081a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Station 300 Gainesville",
      "poi_type": "Entertainment",
      "poi_address": "2317 Browns Bridge Rd, Gainesville, GA 30504, USA",
      "poi_short_description": "Casual entertainment complex featuring bowling lanes, arcade games, laser tag and a bar.",
      "poi_long_description": "Casual entertainment complex featuring bowling lanes, arcade games, laser tag and a bar.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-bf03-704b-8b52-d2c92a83dfdb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-bf03-704b-8b52-d2c92a83dfdb",
        "storage_key": "property/6767906449167570/019fa9a9-bf03-704b-8b52-d2c92a83dfdb.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.station300gainesville.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2621325187656601920&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "station-300-gainesville",
      "poi_latitude": "34.277079",
      "poi_longitude": "-83.85458899999999",
      "poi_miles_from_property": "5.5 mi",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "31 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 770-536-5563",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26ec-73e2-8938-3b8579245c34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26ec-73e2-8938-3b8579245c34",
        "storage_key": "property/6767906449167570/019fa9a6-26ec-73e2-8938-3b8579245c34.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJhxbbLBv09YgRQFEOq17RYCQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_5fc5bc13-e9d9-4ed5-b414-2f4c82026b48",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Northeast Georgia Medical Center Gainesville",
      "poi_type": "Health and Wellness",
      "poi_address": "743 Spring St NE, Gainesville, GA 30501, USA",
      "poi_short_description": "Regional hospital, flagship of Northeast Georgia Health System.",
      "poi_long_description": "Regional hospital, flagship of Northeast Georgia Health System.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a5-f9fd-757b-946c-ecfa986213f3.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a5-f9fd-757b-946c-ecfa986213f3",
        "storage_key": "property/6767906449167570/019fa9a5-f9fd-757b-946c-ecfa986213f3.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.nghs.com/locations/gainesville",
      "poi_directions_map_url": "https://maps.google.com/?cid=3559900896547898260&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northeast-georgia-medical-center-gainesville",
      "poi_latitude": "34.3041926",
      "poi_longitude": "-83.8168211",
      "poi_miles_from_property": "2.6 mi",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-219-9000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26ef-7048-89bf-0c0f9aeede36.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26ef-7048-89bf-0c0f9aeede36",
        "storage_key": "property/6767906449167570/019fa9a6-26ef-7048-89bf-0c0f9aeede36.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJu425Mff29YgRlANVFgFPZzE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_2082e4e1-d1cc-4ef2-9ea1-3b0f2fa668ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Northeast Georgia Physicians Group Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "597 S Enota Dr NE, Gainesville, GA 30501, USA",
      "poi_short_description": "Walk-in urgent care clinic, Northeast Georgia Physicians Group.",
      "poi_long_description": "Walk-in urgent care clinic, Northeast Georgia Physicians Group.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-c163-75af-9827-f55cb9cc2893.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-c163-75af-9827-f55cb9cc2893",
        "storage_key": "property/6767906449167570/019fa9a9-c163-75af-9827-f55cb9cc2893.webp",
        "width": 720,
        "height": 405
      },
      "poi_business_url": "https://www.ngpg.org/urgent-care/gainesville",
      "poi_directions_map_url": "https://maps.google.com/?cid=7885219595984112146&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "northeast-georgia-physicians-group-urgent-care",
      "poi_latitude": "34.3108976",
      "poi_longitude": "-83.8167093",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 770-219-7777",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26ec-73e2-8938-3b8579245c34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26ec-73e2-8938-3b8579245c34",
        "storage_key": "property/6767906449167570/019fa9a6-26ec-73e2-8938-3b8579245c34.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJA0kqNlj29YgREgqV4nHtbW0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_100e4f54-2b4d-4668-9469-8e5401422f97",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Frances Meadows Aquatic Center",
      "poi_type": "Health and Wellness",
      "poi_address": "1545 Community Way, Gainesville, GA 30501, USA",
      "poi_short_description": "Aquatic facility with an outdoor water park, plus an indoor competition pool & instructional pool.",
      "poi_long_description": "Aquatic facility with an outdoor water park, plus an indoor competition pool & instructional pool.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-c4e4-7253-8146-be0fedfc86c5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-c4e4-7253-8146-be0fedfc86c5",
        "storage_key": "property/6767906449167570/019fa9a9-c4e4-7253-8146-be0fedfc86c5.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.gainesville.org/frances-meadows",
      "poi_directions_map_url": "https://maps.google.com/?cid=11166098666250924454&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "frances-meadows-aquatic-center",
      "poi_latitude": "34.309476",
      "poi_longitude": "-83.80728359999999",
      "poi_miles_from_property": "2.0 mi",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 770-533-5850",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26ec-73e2-8938-3b8579245c34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26ec-73e2-8938-3b8579245c34",
        "storage_key": "property/6767906449167570/019fa9a6-26ec-73e2-8938-3b8579245c34.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0WrGXjvs9YgRpnHZkJPz9Zo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_aa002507-8103-47a4-9bd0-1211d529f8a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "The Beast Sports Center, LLC",
      "poi_type": "Health and Wellness",
      "poi_address": "206 College Ave SE, Gainesville, GA 30501, USA",
      "poi_short_description": "Relaxed gym with boxing-ring and weightlifting facilities, plus group classes.",
      "poi_long_description": "Relaxed gym with boxing-ring and weightlifting facilities, plus group classes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a5-f34b-740d-a983-53b538a17926.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a5-f34b-740d-a983-53b538a17926",
        "storage_key": "property/6767906449167570/019fa9a5-f34b-740d-a983-53b538a17926.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.thebeastsportscenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7546907901394317376&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-beast-sports-center-llc",
      "poi_latitude": "34.2957822",
      "poi_longitude": "-83.8222095",
      "poi_miles_from_property": "3.1 mi",
      "poi_walking_minutes": "1 hour 11 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-503-0930",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26ec-73e2-8938-3b8579245c34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26ec-73e2-8938-3b8579245c34",
        "storage_key": "property/6767906449167570/019fa9a6-26ec-73e2-8938-3b8579245c34.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJcb0687_39YgRQHAyR8AAvGg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_7796918c-1bbc-4603-acb5-60bedd6e1440",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Longwood Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "20 Pearl Nix Pkwy, Gainesville, GA 30501, USA",
      "poi_short_description": "Scenic park on the water offering walking trails, playgrounds, picnic tables & tennis courts.",
      "poi_long_description": "Scenic park on the water offering walking trails, playgrounds, picnic tables & tennis courts.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-c751-70d3-9995-99dadff32c15.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-c751-70d3-9995-99dadff32c15",
        "storage_key": "property/6767906449167570/019fa9a9-c751-70d3-9995-99dadff32c15.webp",
        "width": 721,
        "height": 1280
      },
      "poi_business_url": "https://www.gainesville.org/508/Lake-Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=194990664152524364&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "longwood-park",
      "poi_latitude": "34.3038509",
      "poi_longitude": "-83.846857",
      "poi_miles_from_property": "4.3 mi",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 770-531-2680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-296c-74ee-99a9-c2d8fc432613.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-296c-74ee-99a9-c2d8fc432613",
        "storage_key": "property/6767906449167570/019fa9a6-296c-74ee-99a9-c2d8fc432613.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJQWsO_yn09YgRTCZU1_m-tAI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_8d6841cf-dd74-4e61-95d9-7d4c2c36b7c4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Clarks Bridge Park Boat Ramp",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3132 Clarks Bridge Rd, Gainesville, GA 30506, USA",
      "poi_short_description": "Public boat ramp on Lake Lanier at Clarks Bridge Park.",
      "poi_long_description": "Public boat ramp on Lake Lanier at Clarks Bridge Park.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-c82b-7416-bf97-378bafbf384e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-c82b-7416-bf97-378bafbf384e",
        "storage_key": "property/6767906449167570/019fa9a9-c82b-7416-bf97-378bafbf384e.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=3458848466902787919&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "clarks-bridge-park-boat-ramp",
      "poi_latitude": "34.3520155",
      "poi_longitude": "-83.7929367",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 3 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26ec-73e2-8938-3b8579245c34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26ec-73e2-8938-3b8579245c34",
        "storage_key": "property/6767906449167570/019fa9a6-26ec-73e2-8938-3b8579245c34.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJTyC853dYX4gRTyel2VpMADA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_870228e4-855c-40b6-a0c5-b6dd93d36b9b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Linwood Nature Preserve",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "415 Linwood Dr, Gainesville, GA 30501, USA",
      "poi_short_description": "Nature preserve featuring marked trails, plus a lake and a mini water feature.",
      "poi_long_description": "Nature preserve featuring marked trails, plus a lake and a mini water feature.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-c94b-76ef-b112-1d38760fca17.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-c94b-76ef-b112-1d38760fca17",
        "storage_key": "property/6767906449167570/019fa9a9-c94b-76ef-b112-1d38760fca17.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.redbudproject.org/linwood-nature-preserve",
      "poi_directions_map_url": "https://maps.google.com/?cid=9779328576204223986&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "linwood-nature-preserve",
      "poi_latitude": "34.3288546",
      "poi_longitude": "-83.843074",
      "poi_miles_from_property": "4.2 mi",
      "poi_walking_minutes": "1 hour 36 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 770-531-2680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-296c-74ee-99a9-c2d8fc432613.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-296c-74ee-99a9-c2d8fc432613",
        "storage_key": "property/6767906449167570/019fa9a6-296c-74ee-99a9-c2d8fc432613.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnbUknHX29YgR8rV65oYnt4c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_91e646be-8b98-4270-95dd-1a4b9afce074",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Wilshire Trails",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "849 Wilshire Rd, Gainesville, GA 30501, USA",
      "poi_short_description": "Riverside public park area with a covered bridge, gazebos, walking trails & on-site restrooms.",
      "poi_long_description": "Riverside public park area with a covered bridge, gazebos, walking trails & on-site restrooms.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-cad6-71f6-9b4c-66bcae9f22b0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-cad6-71f6-9b4c-66bcae9f22b0",
        "storage_key": "property/6767906449167570/019fa9a9-cad6-71f6-9b4c-66bcae9f22b0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.gainesville.org/Facilities/Facility/Details/Wilshire-Trails-85",
      "poi_directions_map_url": "https://maps.google.com/?cid=11814902199779902530&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "wilshire-trails",
      "poi_latitude": "34.3052937",
      "poi_longitude": "-83.8435947",
      "poi_miles_from_property": "4.1 mi",
      "poi_walking_minutes": "1 hour 34 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 770-531-2680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-296c-74ee-99a9-c2d8fc432613.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-296c-74ee-99a9-c2d8fc432613",
        "storage_key": "property/6767906449167570/019fa9a6-296c-74ee-99a9-c2d8fc432613.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJVbf4goX29YgRQsTc4fP29qM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "city_park"
    },
    {
      "id": "custom_b42729fd-2a31-4b2d-88f1-1d80e14fa6d7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Riverside Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "1267 Riverside Dr, Gainesville, GA 30501, USA",
      "poi_short_description": "City park in Gainesville.",
      "poi_long_description": "City park in Gainesville.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-cda2-726c-984c-4646b1a82edd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-cda2-726c-984c-4646b1a82edd",
        "storage_key": "property/6767906449167570/019fa9a9-cda2-726c-984c-4646b1a82edd.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.gainesville.org/Facilities/Facility/Details/Riverside-Park-27",
      "poi_directions_map_url": "https://maps.google.com/?cid=63996627035516331&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "riverside-park",
      "poi_latitude": "34.3207645",
      "poi_longitude": "-83.8271036",
      "poi_miles_from_property": "2.9 mi",
      "poi_walking_minutes": "1 hour 8 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 770-531-2680",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-296c-74ee-99a9-c2d8fc432613.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-296c-74ee-99a9-c2d8fc432613",
        "storage_key": "property/6767906449167570/019fa9a6-296c-74ee-99a9-c2d8fc432613.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJXbpQI9T39YgRq21G3Zdc4wA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_19a982d2-d5e3-4e3c-be7f-03524360421d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Gainesville",
      "poi_type": "Transportation & Transit",
      "poi_address": "116 Industrial Blvd, Gainesville, GA 30501, USA",
      "poi_short_description": "Amtrak station in Gainesville, a stop on the Crescent line between Atlanta and New York.",
      "poi_long_description": "Amtrak station in Gainesville, a stop on the Crescent line between Atlanta and New York.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-03b9-76c0-ac50-4853e44bd599.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a6-03b9-76c0-ac50-4853e44bd599",
        "storage_key": "property/6767906449167570/019fa9a6-03b9-76c0-ac50-4853e44bd599.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.amtrak.com/servlet/ContentServer?pagename=am/am2Station/Station_Page&code=GNS",
      "poi_directions_map_url": "https://maps.google.com/?cid=16380576991303314299&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gainesville",
      "poi_latitude": "34.2887701",
      "poi_longitude": "-83.81962039999999",
      "poi_miles_from_property": "3.5 mi",
      "poi_walking_minutes": "1 hour 19 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 800-872-7245",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-2968-70e5-9d27-807ca8c57087.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-2968-70e5-9d27-807ca8c57087",
        "storage_key": "property/6767906449167570/019fa9a6-2968-70e5-9d27-807ca8c57087.webp",
        "width": 161,
        "height": 192
      },
      "poi_google_place_id": "ChIJvzdeCun29YgReyuSTvx_U-M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "train_station"
    },
    {
      "id": "custom_28d2a34e-0bcf-47b3-a14b-10b0e4bd6ee8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Hall Area Transit",
      "poi_type": "Transportation & Transit",
      "poi_address": "687 Main St SW, Gainesville, GA 30501, USA",
      "poi_short_description": "Hall County's public transit agency; runs the WeGo on-demand rideshare service in Gainesville.",
      "poi_long_description": "Hall County's public transit agency; runs the WeGo on-demand rideshare service in Gainesville.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-d11e-751b-a97a-56a7f99d27a4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-d11e-751b-a97a-56a7f99d27a4",
        "storage_key": "property/6767906449167570/019fa9a9-d11e-751b-a97a-56a7f99d27a4.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://rymaps.org/business/hall-area-transit-te3eox",
      "poi_directions_map_url": "https://maps.google.com/?cid=2092857801309914117&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hall-area-transit",
      "poi_latitude": "34.2940052",
      "poi_longitude": "-83.8232799",
      "poi_miles_from_property": "3.4 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "22 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-503-3333",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26ec-73e2-8938-3b8579245c34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26ec-73e2-8938-3b8579245c34",
        "storage_key": "property/6767906449167570/019fa9a6-26ec-73e2-8938-3b8579245c34.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJzaQ0Wuz29YgRBYR79BRTCx0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_79b46b68-cb2e-448b-aebf-fae15a947279",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Greyhound: Bus Station",
      "poi_type": "Transportation & Transit",
      "poi_address": "2580 Monroe Dr, Gainesville, GA 30507, USA",
      "poi_short_description": "Intercity bus stop served by Greyhound.",
      "poi_long_description": "Intercity bus stop served by Greyhound.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-d3a2-706f-898c-78a93bbbca68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-d3a2-706f-898c-78a93bbbca68",
        "storage_key": "property/6767906449167570/019fa9a9-d3a2-706f-898c-78a93bbbca68.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.greyhound.com/bus/gainesville-ga/gainesville-shell?utm_source=google_maps&utm_medium=organic",
      "poi_directions_map_url": "https://maps.google.com/?cid=637703751554877603&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "greyhound-bus-station",
      "poi_latitude": "34.2827445",
      "poi_longitude": "-83.8005742",
      "poi_miles_from_property": "3.8 mi",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 800-231-2222",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26ec-73e2-8938-3b8579245c34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26ec-73e2-8938-3b8579245c34",
        "storage_key": "property/6767906449167570/019fa9a6-26ec-73e2-8938-3b8579245c34.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB63XdSH39YgRo8hc7y6U2Qg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "transportation_service"
    },
    {
      "id": "custom_3b8d8918-7a26-4ce0-aabb-15a278934a26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Hall County School District",
      "poi_type": "Major Employers & Offices",
      "poi_address": "711 Green St, Gainesville, GA 30501, USA",
      "poi_short_description": "Public school district serving Hall County; district offices.",
      "poi_long_description": "Public school district serving Hall County; district offices.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-d9a9-76f6-9d62-683bb9539704.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-d9a9-76f6-9d62-683bb9539704",
        "storage_key": "property/6767906449167570/019fa9a9-d9a9-76f6-9d62-683bb9539704.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.hallco.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9893455110677567290&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hall-county-school-district",
      "poi_latitude": "34.308632",
      "poi_longitude": "-83.8276595",
      "poi_miles_from_property": "3.3 mi",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "23 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 770-534-1080",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26c0-7056-9732-43a6c2dc4e03.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26c0-7056-9732-43a6c2dc4e03",
        "storage_key": "property/6767906449167570/019fa9a6-26c0-7056-9732-43a6c2dc4e03.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ1T2Jm4r29YgROpc1YQGdTIk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_8cef3a51-18cf-4ce6-bb44-997318014f9f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "poi_name": "Kubota Manufacturing of America - Gainesville Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2715 Ramsey Rd, Gainesville, GA 30501, USA",
      "poi_short_description": "Manufacturer of Kubota tractors and equipment; one of Hall County's largest employers.",
      "poi_long_description": "Manufacturer of Kubota tractors and equipment; one of Hall County's largest employers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a9-dc27-734e-a35c-c859c60b70fc.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019fa9a9-dc27-734e-a35c-c859c60b70fc",
        "storage_key": "property/6767906449167570/019fa9a9-dc27-734e-a35c-c859c60b70fc.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.kubota-kma.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13099027342759896158&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kubota-manufacturing-of-america---gainesville-campus",
      "poi_latitude": "34.3490911",
      "poi_longitude": "-83.78046479999999",
      "poi_miles_from_property": "2.3 mi",
      "poi_walking_minutes": "52 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 770-532-0038",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fa9a6-26ec-73e2-8938-3b8579245c34.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019fa9a6-26ec-73e2-8938-3b8579245c34",
        "storage_key": "property/6767906449167570/019fa9a6-26ec-73e2-8938-3b8579245c34.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJt9Bg_OP39YgRXiRVdPcXybU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    }
  ],
  "office_hours": [
    {
      "id": "ec_cd26b67ce1975bb59e57b5da",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "day": "MON",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_ec43b0cc5884e2e0420f0327",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "day": "TUE",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_96ff14333beceec088ecfdc8",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "day": "WED",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_da4e4f40022869c64cf58481",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "day": "THU",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_4f2fcc42c65a30d8ad2b6ee4",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "day": "FRI",
      "open_time": "09:00",
      "close_time": "18:00"
    },
    {
      "id": "ec_94aba673b82fd6e7a428100d",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "ec_514f60390b232e7269a99e6a",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "rating": "4",
      "name": "Setting Standards High",
      "text": "Toured these townhomes and I must say they are beautiful so is the community. I would’ve given 5 stars but the layout of the two 4 bedrooms which l want has me torn. The 3 story is perfect for entertaining with the spacious living and dining area but the secondary bedrooms upstairs are tiny and master closet and bathroom is small. You get no driveway or backyard with the 3 story only a garage. A balcony would’ve been nice to make up for that. The 2 story 4 bedroom has the perfect size bedrooms and closets but the living room and dining space is small. You get a cute little backyard yard space and driveway with the 2 story. There’s a train track literally in front of community so if you’re sensitive to noise I would select a unit on backside. The train was really loud. There’s also a youth detention center right before community, but the area is minutes away from restaurants, access to highway, Lanier Technical College, YMCA, and much more. Definitely has many perks that outweigh other things. I strongly encourage going to do the in person self guided tour before applying. It’s on my top 3 places to move if there’s any available when my lease expires although I’m torn between the two 4 bedroom models. Reducing the loft space and expanding those secondary bedrooms in the 3 story would’ve made this community my #1.",
      "date": "2026-05-30",
      "title": "false"
    },
    {
      "id": "ec_f18e8f7260d4dec93c0939b2",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "rating": "5",
      "name": "Rayelle Cook",
      "text": "Me & my sister got a tour from william. Honestly He was great, answered all of our questions, gave us some advice on renting being that fact this would be our first time. Gave us some tips . We toured a 3 bedroom & a 4 bedroom 2 story home . also met some of the neighbors & i can say i love this neighborhood already. William was very patient and gave me and my sister enough time and space to see how we like the home, he didn’t rush us and he didn’t pressure us into anything he kinda went with the flow and i love that . I definitely recommend this neighborhood. All in All william was great, Wish him nothing but blessings and many more.",
      "date": "2025-10-16",
      "title": "false"
    },
    {
      "id": "ec_7b15948b284e3d593eaeef89",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "rating": "5",
      "name": "omar jesus lugo gutierrez",
      "text": "Excellent service from Ana; I was very pleased with the information she provided. The houses are beautiful and of exceptional quality—I highly recommend seeing and renting them.",
      "date": "2026-04-14",
      "title": "false"
    },
    {
      "id": "ec_8012733ade5676e9711167c0",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "rating": "5",
      "name": "Ivette Johana León Leal",
      "text": "The people who work there are very friendly. They explain every aspect of the properties in detail. The houses are beautiful and welcoming.",
      "date": "2026-02-26",
      "title": "false"
    },
    {
      "id": "ec_6fb089e5bdbb0924ac23f4a5",
      "source": "google_places",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "rating": "5",
      "name": "Talonda Sowell",
      "text": "William was very energetic and helpful when touring me! Offered me Snacks and allowed me to take my time touring the Vandermeer. Check them out! 😊",
      "date": "2025-12-02",
      "title": "false"
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_89ea01c8-e229-4265-9790-7b35eece5538",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "3D walkthrough of the Valehaven townhome (4 bed, 2.5 bath, 1,668 sq ft)",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/019fae3d-12f0-7198-aca4-400fa52e9443.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "019fae3d-12f0-7198-aca4-400fa52e9443",
        "storage_key": "property/6767906449167570/019fae3d-12f0-7198-aca4-400fa52e9443.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Valehaven",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=BMnW1HxSodX"
    },
    {
      "id": "custom_15d02edb-89e7-4775-a135-0db3910d6d3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a0cf5d-edcf-702f-8655-4161ba582ab9.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0cf5d-edcf-702f-8655-4161ba582ab9",
        "storage_key": "property/6767906449167570/01a0cf5d-edcf-702f-8655-4161ba582ab9.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "Vandermeer",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=u1sB6993dyi"
    },
    {
      "id": "custom_f71335e9-43ed-49c4-9870-e5e2e89c6e67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449167570/01a0cf5e-90e2-75b1-88c8-65be1364a725.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": null,
        "public_id": "01a0cf5e-90e2-75b1-88c8-65be1364a725",
        "storage_key": "property/6767906449167570/01a0cf5e-90e2-75b1-88c8-65be1364a725.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Vanderbilt",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=qXfXu6WDFx1"
    }
  ],
  "faqs": [
    {
      "id": "custom_6101164c-f548-4c27-9d4e-f588ec95cedf",
      "question": "Application Fee",
      "answer": "$100 per person for all occupants over 18.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_e7b05237-4684-4f93-9fc1-7b3900d10473",
      "question": "Administration Fee & Additional Charges",
      "answer": "A one-time administration fee of $350 is required at move-in. Please review the information below regarding additional charges and fees that may arise throughout your lease term.",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_9053c26c-30f1-4658-8bae-12e53d995c8d",
      "question": "Utility Billing Fee",
      "answer": "$11.99/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_cf075901-97db-4c9f-bec4-916d5fbe5ae9",
      "question": "Pet Fees",
      "answer": "Non-refundable pet fee of $300 for one pet ($500 for two pets). Pet rent $35/month per pet",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_4223ea14-b8a5-408a-9a78-00896c794dd6",
      "question": "Concierge Package",
      "answer": "$10.95/month Bi-annual filter change Exterior pest control 24 hour maintenance response on emergencies Positive credit reporting",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_8f5e2f0d-d5a7-4abf-ac04-16b30b418596",
      "question": "Smart Home",
      "answer": "Smart Home Fee - $35/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_a81fe663-7604-440a-b081-afd29261495f",
      "question": "Trash",
      "answer": "$25/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_bead9f6a-77e2-4cfa-ae76-dabf1423b1c3",
      "question": "Landscape Services",
      "answer": "$80/month",
      "category": "Deposit & Mandatory Fee Guide",
      "source": "custom"
    },
    {
      "id": "custom_0bbdd1de-6318-4cb3-837d-891abfa170c9",
      "question": "Occupancy Guidelines",
      "answer": "The maximum occupancy for Quinn properties is two (2) persons per bedroom, plus one (1) additional occupant per home. Occupancy standards may vary by region based on local city, county, and state laws.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_91d8bdf0-0df3-4ec7-8d30-308ea056284e",
      "question": "Application",
      "answer": "All adults, 18 years of age, or considered an adult under state law, are required to complete an application in its entirety. All occupants applying for the property must reside in the property. By acknowledging the terms and conditions outlined in the Quinn rental criteria, the Applicant confirms all information provided is true and accurate. Any falsification, fabrication, or untruthful answers and supporting documentation shall result in an automatic denial. Applicants are required, unless otherwise noted, to pay a $100.00 non-refundable application fee to authorize a background check and additional qualification processes; Properties may not be held off the market for greater than ten (10) days, unless a Quinn representative approves an extension. All applicants are required, unless otherwise specified, to pay a non-refundable $350 administration fee to secure a specific home and remove it from the market. All administration fees are non-refundable unless the application is declined. Upon Applicant approval, Leases are required to be signed within 24 hours of generation. In the event Lease is not signed within the 24-hour time Quinn may elect to cancel the application and place the home back on the market. All Applicants are required to provide valid identification. Non-US citizens applying to a home may be required to present information acknowledging the individual's right to live in the United States through the duration of the lease term. Approved applications are valid for thirty (30) days, after that time period, all Applicants must provide written consent for additional screening, credit checks, income verification, and re-qualification for a property managed by Quinn PM LLC. Any application that provides falsified or incorrect information may be subject to automatic disqualification. If an Applicant falsifies their application or supporting documentation, Quinn has the right to hold all deposits and fees paid to apply towards liquidated damages. DISCLAIMER: Rentgrow reports information about applicants in accordance with the applicable state and federal law. However, other federal, state or local laws and regulations may apply. This application, even if accepted, shall under no circumstances be considered a lease agreement between Applicant and Quinn, nor an offer to lease, and does not create a landlord/tenant relationship. No lease shall exist between an Applicant and Quinn unless and until the parties enter a fully executed Lease Agreement conditioned on the Applicant paying all required fees, security deposits, and rent. At Quinn PM LLC's sole discretion, Quinn PM LLC reserves the right to cancel an approved application, and refuse occupancy to any applicant(s) who disrupts or interferes with Landlord's business operations, or communicates with Landlord, Landlord's agents, or their employees in an unreasonable, discourteous, rude, or hostile manner.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_9cbce655-800c-4b49-aa56-5eca2abebc5f",
      "question": "Guarantors",
      "answer": "Guarantors may be accepted to support an application and must complete all required application and screening processes. Applicants who do not independently meet qualification criteria may also have the option to utilize a third-party lease guarantee program through TheGuarantors, which does not add an additional occupant or leaseholder.",
      "category": "Application Requirements",
      "source": "custom"
    },
    {
      "id": "custom_688787b8-f458-4c31-985f-ac5f98d21470",
      "question": "Income",
      "answer": "Income Requirements: Household income requirements are based upon the market and other qualification factors within the application process. In-State Income Verification: Proof of income being made in the state where you are wishing to rent a home is required. Examples include, but are not limited to, state taxes shown on your pay statements, an offer letter or transfer letter confirming you are beginning a new role in that state, or proof that you are a remote employee. Job Transfer/New Role: Applicants with an offer of employment or transfer of role from their existing employer are required to provide an Offer Letter or Transfer Letter on employer letterhead confirming terms of compensation and start date. The letter should be signed and dated by the offeror. Contract-Based Employment: At select communities, an additional income verification option may be available for applicants working on a contract basis. This may include providing a notarized letter on company letterhead confirming income from Human Resources, Payroll, the business owner, or a company officer. Additional documentation may be required to verify the stated income. Additional Income Sources: Social Security Benefits, Child Support, Alimony, Disability, Retirement, Pensions, VA Benefits and complete Bank Statements are accepted. Items containing redacted or otherwise altered information are subject to additional verification and/or denial. Additional Documentation: Quinn may request additional proof of income if the documents provided are insufficient. False or Altered Documentation: Applicants who provide any false, counterfeit, or other fake documentation are subject to denial, even if discovered after approval. Any falsified documents will result in a denial.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_3b9597f0-3d46-4cda-bba4-f8c00d804ba6",
      "question": "Security Deposit",
      "answer": "An applicant's security deposit is determined by the score of the applicant and may result in an increased security deposit for approval.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_e0a0f703-2448-465e-983e-a6bce4089da4",
      "question": "Credit Report",
      "answer": "All applicant's credit history enters a scoring model to determine qualifications for each application. The SafeRent Score is determined from an analysis of information found in each applicant's consumer credit report, application, and previous rental histories (if applicable). Consumer reports may include but are not limited to payment history, bankruptcies, number and type of accounts, collection activity, outstanding debt and credit inquiries. In addition, the scoring process includes income-to-rent ratio, eviction records, and subprime credit records. Current Open Bankruptcies (Chapter 7 or 13) will result in an automatic denial. Applicants are subject to further verification at the request of a Quinn representative. For applications in the state of South Carolina: Applicant(s) does hereby consent upon completion and meeting the criteria of a credit and rental history screening, a criminal background report will be processed by Quintasen Holdings, LLC to complete screening of the consumer information report.",
      "category": "Credit & Finance",
      "source": "custom"
    },
    {
      "id": "custom_617b99f7-83f3-40e3-9c7e-d55009dc584b",
      "question": "Rental History",
      "answer": "Prior Evictions, filed or enforced, may result in an automatic denial of the application. Any outstanding debt or judgment owed to any prior landlord may result in a denial. Quinn may request rental verification if rental history cannot be verified.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_a4ed3a95-d58e-48f0-b912-6720d6244d07",
      "question": "Criminal History",
      "answer": "Each Applicant is subject to a criminal background check. Criminal background screening is broken into the following categories 1) Crimes Against Persons, 2) Property, and 3) Society. Criminal histories presented through applicant screening reports pertaining to weapons, drugs, violence, or any other act that poses a threat to household, neighborhood, vendors, Quinn employees, or the physical property itself, may result in a denial. Criminal history will be assessed on the risk to persons or property by an applicant including but not limited to the type of crime; the severity of the crime; circumstance of the crime; and the length of time since the crime occurred. Denied Applicants may dispute any wrongful record claims by contacting Screening Works and following the process as outlined in their action letter and Screening Works. Criminal background screening is also governed by federal, state or local laws which regulate Quinn's screening processes. An Office of Foreign Assets Control (OFAC) search is completed for each Applicant. If Applicant appears on the OFAC list, the application will be denied.",
      "category": "Leasing History",
      "source": "custom"
    },
    {
      "id": "custom_d9e40785-c029-4e3b-90e6-5a9505da9275",
      "question": "Pets",
      "answer": "Pet Screening: Mandatory for all applicants before move-in. Pet Restrictions: Restricted breeds include Pit Bull, Rottweiler, Cane Corso, American Staffordshire Terrier, Bull Terrier, and American Bulldog, or any crossbreeds of these. Maximum weight limit of 100 pounds per pet. No more than two (2) pets allowed unless written approval is obtained from Quinn Property Management. Fees: Non-refundable pet fee of $300 for one pet; $500 for up to two pets. Monthly pet rent of $35 per pet. Prohibited Animals: Dangerous or poisonous animals and exotic pets are not permitted. Fish Tanks: Limited to 20 gallons. No pet fee or pet rent required for fish. Assistive Animals: Animals assisting persons with disabilities are exempt from these restrictions and are not considered pets. Vaccinations and Registrations: All pets must have up-to-date vaccinations and current state, city, and county registrations. Visiting Animals: No visiting animals allowed under any circumstances.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_5e67c2f9-cebb-4483-bcc5-34cf872b7400",
      "question": "Assistance Animals",
      "answer": "No Cost - Pet screening is mandatory as part of the application process prior to move in with a 2-5 business day approval turnaround time. Assistive Animals for persons with disabilities are not considered to be pets and are not subject to the pet restrictions bestowed in this section.",
      "category": "Pets & Animals",
      "source": "custom"
    },
    {
      "id": "custom_79eccc62-f176-4e14-b9b9-8644e710d0a3",
      "question": "Vehicles",
      "answer": "No more than four (4) vehicles are permitted on the Premises. Vehicles must be operational and have current and valid registration based upon state law. Additional HOA restrictions may apply to the number of vehicles, commercial vehicles and allowed parking locations. If your home is contained in an HOA review the HOA's restrictive covenants for more information regarding vehicle guidelines.",
      "category": "Vehicles",
      "source": "custom"
    },
    {
      "id": "custom_a2bc8e15-166c-4dee-86b0-ad19560bcb5b",
      "question": "Renters Insurance",
      "answer": "To alleviate concerns and help you protect what matters most we have partnered with Assurant, a preferred insurance provider, to make the process of protecting your home and property seamless. We know how busy life can be, and we wanted to provide you an option that makes the selection of an insurance policy simple, while meeting your lease requirements. Please visit this page for more information on renters insurance requirements.",
      "category": "Renters Insurance",
      "source": "custom"
    }
  ],
  "fees": [],
  "pet_policies": [
    {
      "id": "ec_d128a86afea3e623aed2096d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "yardi",
      "external_id": "2486073",
      "pet_type": "all",
      "allowed": true,
      "max_count": 3,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 300,
      "monthly_rent": 35,
      "description": "false",
      "restrictions": "Contact Management"
    },
    {
      "id": "ec_6dad4323556ae2f3c14b7143",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "yardi",
      "external_id": "2681170",
      "pet_type": "cats",
      "allowed": true,
      "max_count": 0,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 300,
      "monthly_rent": 35,
      "description": "false",
      "restrictions": "false"
    },
    {
      "id": "ec_d723eaf6a7baa6679843f85f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "yardi",
      "external_id": "2681169",
      "pet_type": "dogs",
      "allowed": true,
      "max_count": 0,
      "weight_limit": 0,
      "deposit": 0,
      "fee": 300,
      "monthly_rent": 35,
      "description": "false",
      "restrictions": "false"
    }
  ],
  "lead_collectors": [
    {
      "lead_collector_id": "01a0abe0-8eb2-7358-b7fa-b63e71f0b4c2",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "Crescent Valley Property Website",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570"
    },
    {
      "lead_collector_id": "01a0abe0-8f3d-7368-a1c1-c95a74440c56",
      "lead_source": "LANDING_PAGE",
      "name": "Crescent Valley Landing Page",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "generator",
      "page_item_url": "pet-friendly-apartments-gainesville-ga",
      "search_query": "pet friendly apartments Gainesville GA",
      "category": "Amenity",
      "h1_title": "Pet Friendly Apartments in Gainesville, GA",
      "h2_subtitle": "Discover pet-friendly living at Crescent Valley, located in beautiful Gainesville, GA. Enjoy luxury amenities with your furry friends.",
      "page_copy": "Welcome to Crescent Valley, where pet-friendly living meets unparalleled comfort in Gainesville, GA. Our community proudly welcomes pets, offering plenty of room for you and your furry companions to roam and enjoy. Nestled in Hall County, this delightful sanctuary is perfect for pet owners seeking modern amenities and convenient access to outdoor activities.\n\nResidents of Crescent Valley benefit from thoughtfully designed, pet-friendly apartments with premium features such as luxury flooring and in-unit cable. Your pets will love exploring the scenic surroundings while you enjoy top-tier amenities including a sparkling pool and a pickleball court. Embrace the vibrant, pet-inclusive lifestyle here at Crescent Valley in Gainesville.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet Friendly Apartments in Gainesville, GA",
      "seo_description": "Find pet friendly apartments at Crescent Valley in Gainesville, GA. Enjoy luxury amenities and a welcoming community for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "generator",
      "page_item_url": "apartments-with-pool-hall-county",
      "search_query": "apartments with pool Hall County",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in Hall County",
      "h2_subtitle": "Crescent Valley offers stunning apartments with a pool right in Hall County. Enjoy a refreshing lifestyle in our premier community.",
      "page_copy": "Dive into luxury living at Crescent Valley, where apartments with a pool await you in the heart of Hall County. Whether you're looking to relax poolside or take a refreshing swim, our sparkling outdoor pool is the perfect spot for leisure and socializing with neighbors.\n\nLocated conveniently in Gainesville, GA, Crescent Valley offers more than just a pool. Our community features luxurious amenities such as in-unit cable, modern luxury flooring, and a fun pickleball court, creating a vibrant living experience. Embrace the ultimate comfort and style at Crescent Valley, where a beautiful pool is just one of our many attractive features.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pool in Hall County",
      "seo_description": "Discover Crescent Valley in Hall County, offering beautiful apartments with a pool and modern amenities to enhance your lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "generator",
      "page_item_url": "smart-home-apartments-30501",
      "search_query": "smart-home technology apartments 30501",
      "category": "Amenity",
      "h1_title": "Smart-Home Apartments in 30501",
      "h2_subtitle": "Experience innovative living with smart-home technology at Crescent Valley, ideally located in the 30501 zip code.",
      "page_copy": "Welcome to Crescent Valley, where advanced smart-home technology meets comfort and style in the 30501 area. Our cutting-edge apartments are designed to enhance your lifestyle with the convenience of modern technology integrated into your living space.\n\nImagine controlling your home environment with just a touch, while also enjoying luxury amenities such as a refreshing pool, exclusive pickleball court, and in-unit cable. Situated in the vibrant Gainesville community, Crescent Valley offers more than just tech-savvy living—it's the ideal place for those seeking innovation and luxury. Embrace the future at Crescent Valley, where smart-home technology is just the beginning.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Smart-Home Apartments in 30501",
      "seo_description": "Discover Crescent Valley's smart-home technology apartments in 30501, combining modern living with luxury amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "generator",
      "page_item_url": "apartments-pickleball-courts-gainesville",
      "search_query": "apartments with pickleball courts Gainesville",
      "category": "Amenity",
      "h1_title": "Apartments with Pickleball Courts Gainesville",
      "h2_subtitle": "Enjoy active living at Crescent Valley, featuring apartments with pickleball courts in Gainesville. Experience community and fun close to home.",
      "page_copy": "Crescent Valley invites you to elevate your lifestyle with our unique pickleball courts, located in the vibrant city of Gainesville. Perfect for residents seeking an active community, our courts provide a fantastic opportunity to engage in this fast-paced, social sport right at home.\n\nBeyond offering pickleball, Crescent Valley combines luxury and convenience with comfortable apartments featuring modern amenities like luxury flooring and in-unit cable. Residents also have access to our refreshing pool, creating a well-rounded and exciting living environment. Discover the perfect blend of recreation and relaxation at Crescent Valley, where your active lifestyle is our priority.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with Pickleball Courts Gainesville",
      "seo_description": "Find Crescent Valley in Gainesville, offering modern apartments with pickleball courts and other luxury amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "generator",
      "page_item_url": "luxury-kitchen-appliances-gainesville-apartments",
      "search_query": "luxury kitchen appliances Gainesville apartments",
      "category": "Amenity",
      "h1_title": "Luxury Kitchen Appliances in Gainesville",
      "h2_subtitle": "Crescent Valley offers Gainesville apartments equipped with luxury kitchen appliances, designed to upgrade your culinary adventures.",
      "page_copy": "Experience the pinnacle of modern living at Crescent Valley, where luxury kitchen appliances are a hallmark of our Gainesville apartments. Designed with both style and functionality in mind, our kitchens provide the perfect setting for anyone who enjoys cooking and entertaining.\n\nLocated in the heart of Gainesville, Crescent Valley not only offers premium kitchens but also a range of high-end amenities. From our pristine pool and engaging pickleball court to in-unit cable, every aspect of our community is created to enhance your lifestyle. Discover how Crescent Valley redefines apartment living with quality and luxury at every turn.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Kitchen Appliances Gainesville",
      "seo_description": "Explore Gainesville apartments with luxury kitchen appliances at Crescent Valley, offering a truly modern and stylish living experience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "generator",
      "page_item_url": "four-bedroom-apartments-gainesville-ga",
      "search_query": "four bedroom apartments gainesville ga",
      "category": "Floorplan",
      "h1_title": "Four Bedroom Apartments Gainesville, GA",
      "h2_subtitle": "Discover spacious four bedroom apartments at Crescent Valley in Gainesville, GA, perfect for families or roommates seeking comfort and style.",
      "page_copy": "Crescent Valley presents four bedroom apartments in Gainesville, GA, offering ample space and modern amenities for families or groups. These thoughtfully designed apartments provide the perfect balance of comfort and functionality, with plenty of room for everyone.\n\nEnjoy the luxury of sophisticated living with the community's premier amenities, including a beautiful pool, active pickleball court, and convenient in-unit cable. Situated in a desirable Gainesville location, Crescent Valley ensures convenience and relaxation. Elevate your living experience with our spacious four bedroom options tailored to meet diverse lifestyle needs.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Four Bedroom Apartments Gainesville, GA",
      "seo_description": "Explore Crescent Valley's spacious four bedroom apartments in Gainesville, GA, featuring modern amenities and ample living space.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-hall-county",
      "search_query": "three bedroom apartments hall county",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments in Hall County",
      "h2_subtitle": "Crescent Valley offers spacious three bedroom apartments located in the heart of Hall County, designed for comfortable family living.",
      "page_copy": "Nestled in the vibrant Hall County, Crescent Valley offers three bedroom apartments that cater to families and roommates looking for ample living space and modern convenience. Designed with a focus on comfort, these apartments provide an ideal setting for creating a cozy home.\n\nOur community is enriched with exceptional amenities, including luxury flooring throughout, a sparkling pool, and an engaging pickleball court. Located conveniently in the vicinity of Gainesville, residents enjoy a perfect balance of tranquility and accessibility, making Crescent Valley an excellent choice for those seeking a three bedroom home in Hall County.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Three Bedroom Apartments Hall County",
      "seo_description": "Discover Crescent Valley's spacious three bedroom apartments in Hall County, offering luxury and modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "generator",
      "page_item_url": "apartments-near-brenau-university-gainesville-ga",
      "search_query": "apartments near Brenau University Gainesville GA",
      "category": "School",
      "h1_title": "Apartments Near Brenau University",
      "h2_subtitle": "Discover convenient apartments near Brenau University at Crescent Valley, providing the perfect blend of comfort and proximity in Gainesville, GA.",
      "page_copy": "Crescent Valley offers ideal living solutions for students and faculty seeking apartments near Brenau University in Gainesville, GA. With our prime location, you're just minutes away from campus, allowing for easy commutes and a seamless college experience.\n\nOur apartments feature a host of modern amenities, including washer units, luxury flooring, and cable connectivity, ensuring a comfortable and enjoyable living environment. Additionally, community features such as a refreshing pool and a popular pickleball court make Crescent Valley not only a convenient choice but also a welcoming place to call home. Embrace the perfect balance of academic and leisure living at Crescent Valley.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Brenau University GA",
      "seo_description": "Explore Crescent Valley's convenient apartments near Brenau University in Gainesville, GA, offering modern amenities and easy campus access.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "generator",
      "page_item_url": "apartments-near-northeast-georgia-medical-center",
      "search_query": "apartments near Northeast Georgia Medical Center Gainesville 30501",
      "category": "Hospital",
      "h1_title": "Apartments Near Northeast Georgia Medical Center",
      "h2_subtitle": "Find comfort in apartments near Northeast Georgia Medical Center at Crescent Valley, located conveniently in Gainesville, 30501.",
      "page_copy": "For those seeking apartments near Northeast Georgia Medical Center in Gainesville, 30501, Crescent Valley offers the perfect blend of convenience and modern living. Our community is situated just a short drive from the medical center, making it ideal for healthcare professionals and families who value proximity to work and essential services.\n\nCrescent Valley's apartments come equipped with premium amenities, including luxury flooring, in-unit washers, and in-unit cable access. Residents can also enjoy community features such as our inviting pool and a lively pickleball court. With such a comfortable and accessible location, Crescent Valley ensures a balanced lifestyle for those connected to the Northeast Georgia Medical Center.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Northeast Georgia Medical Center GA",
      "seo_description": "Explore Crescent Valley's convenient apartments near Northeast Georgia Medical Center in Gainesville, 30501, with modern amenities and close proximity.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "generator",
      "page_item_url": "apartments-near-don-carter-state-park",
      "search_query": "apartments near Don Carter State Park Gainesville GA",
      "category": "Park",
      "h1_title": "Apartments Near Don Carter State Park",
      "h2_subtitle": "Enjoy nature at Crescent Valley, offering apartments near Don Carter State Park in vibrant Gainesville, GA.",
      "page_copy": "Located close to the natural beauty of Don Carter State Park, Crescent Valley provides a unique living experience in Gainesville, GA. Our apartments offer convenient access to outdoor adventures, making them a perfect choice for nature enthusiasts and families seeking proximity to the park.\n\nCrescent Valley’s residences are designed with comfort and style, featuring luxury flooring and in-unit amenities such as washers and cable. The community amenities, including a sparkling pool and a pickleball court, further enhance the lifestyle of those who appreciate a blend of leisure and outdoor fun. Discover the perfect balance of natural and urban living near Don Carter State Park.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Don Carter State Park GA",
      "seo_description": "Experience Crescent Valley's ideal location with apartments near Don Carter State Park in Gainesville, GA, featuring modern amenities and natural surroundings.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "generator",
      "page_item_url": "apartments-close-atlanta-botanical-garden-gainesville",
      "search_query": "apartments close to Atlanta Botanical Garden Gainesville",
      "category": "Park",
      "h1_title": "Apartments Close to Atlanta Botanical Garden",
      "h2_subtitle": "Discover serene living at Crescent Valley, offering apartments close to the Atlanta Botanical Garden in Gainesville.",
      "page_copy": "Nestled conveniently in Gainesville, Crescent Valley provides the ideal setting for those seeking apartments close to the Atlanta Botanical Garden. Our prime location offers residents easy access to this botanical haven, perfect for weekend visits and floral enthusiasts alike.\n\nResidents of Crescent Valley enjoy upscale amenities such as luxury flooring and in-unit washers, along with community extras like a pool and pickleball court. Our proximity to the Atlanta Botanical Garden allows residents to immerse themselves in natural beauty while benefiting from modern conveniences and a welcoming community environment. Crescent Valley is your gateway to a harmonious lifestyle in Gainesville.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Atlanta Botanical Garden GA",
      "seo_description": "Crescent Valley offers modern apartments close to the Atlanta Botanical Garden in Gainesville, featuring excellent amenities and a serene environment.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "generator",
      "page_item_url": "apartments-near-laurel-park-hall-county",
      "search_query": "apartments near Laurel Park Hall County",
      "category": "Park",
      "h1_title": "Apartments Near Laurel Park Hall County",
      "h2_subtitle": "Live close to nature at Crescent Valley with apartments near Laurel Park in Hall County.",
      "page_copy": "Crescent Valley presents an exceptional living opportunity with apartments near Laurel Park in Hall County. Situated in a vibrant community known for its natural beauty, our location is perfect for outdoor enthusiasts and families who cherish time in expansive green spaces.\n\nOur apartments boast a range of modern conveniences, including luxury flooring and in-unit washers, ensuring comfort at home. Just a short distance from Laurel Park, Crescent Valley allows you to enjoy leisurely walks, picnics, or boating days at the park. In addition, our residents delight in community amenities like the pool and pickleball court, making Crescent Valley a wonderful place to call home.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Laurel Park Hall County",
      "seo_description": "Find your ideal home at Crescent Valley, offering apartments near Laurel Park in Hall County with top-notch amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "generator",
      "page_item_url": "apartments-close-lake-lanier-olympic-park-30501",
      "search_query": "apartments close to Lake Lanier Olympic Park 30501",
      "category": "Park",
      "h1_title": "Apartments Close to Lake Lanier Olympic Park",
      "h2_subtitle": "Experience lakeside living at Crescent Valley, offering apartments close to Lake Lanier Olympic Park in 30501.",
      "page_copy": "Crescent Valley provides an exceptional living experience with its apartments close to Lake Lanier Olympic Park, situated in the heart of Gainesville's 30501 area. Our community is ideally located for those who love the excitement and serenity of lakeside activities, offering quick access to this renowned venue.\n\nWith luxurious features like premium flooring and in-unit washers, our apartments offer a blend of style and practicality. Residents enjoy a host of community amenities, including a pool and a pickleball court, complementing the active lifestyle encouraged by proximity to Lake Lanier Olympic Park. Crescent Valley embodies both convenience and a connection to nature’s grandeur.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to Lake Lanier Olympic Park GA",
      "seo_description": "Discover Crescent Valley's prime location, offering apartments close to Lake Lanier Olympic Park in 30501 with luxury amenities and a lakeside lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162464",
      "property_id": "6767906449167570",
      "source": "generator",
      "page_item_url": "apartments-near-lanier-point-park-gainesville",
      "search_query": "apartments near Lanier Point Park Gainesville",
      "category": "Park",
      "h1_title": "Apartments Near Lanier Point Park Gainesville",
      "h2_subtitle": "Find your perfect home at Crescent Valley, with apartments near Lanier Point Park in Gainesville.",
      "page_copy": "Crescent Valley is the perfect choice for those looking for apartments near Lanier Point Park in Gainesville. Our location offers the ideal blend of city convenience and park proximity, allowing residents to enjoy the natural beauty of Lanier Point Park while benefiting from the vibrant community of Gainesville.\n\nOur residents enjoy modern amenities, such as luxury flooring and in-unit washers, which provide comfort and convenience. The community also features a refreshing pool and a pickleball court, enhancing the recreational lifestyle that Lanier Point Park complements perfectly. Living at Crescent Valley means embracing both outdoor fun and modern living convenience.",
      "featured_image": null,
      "featured_image_media": null,
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Lanier Point Park Gainesville",
      "seo_description": "Explore Crescent Valley’s modern apartments near Lanier Point Park Gainesville, offering a blend of comfort and proximity to nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "12977262122"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-WGVKTDMW"
    },
    {
      "ID": "custom_rollout_phase",
      "type": "STRING",
      "value": "Phase 2"
    },
    {
      "ID": "custom_perq_script_url",
      "type": "STRING",
      "value": "https://crescentvalleyhomes.fatwin.com/api/websites/resources/1?x=dTBTeTFxZVV4WWpJbFVueGlRNUhPSkhKRGN1VXRuckMyeXRWaExIcTZGR3lRV1BaOFdpZUdoanhBOVJEa3FEVFhRdkZKcU5KeXFOTk9Bb1dZdGxpRlE9PQ2"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "full_stack"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "57142570538"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "none"
    },
    {
      "ID": "custom_engrain_sightmap_url",
      "type": "STRING",
      "value": "https://sightmap.com/embed/yzvg89q1pln"
    },
    {
      "ID": "custom_self_guided_tour_url",
      "type": "STRING",
      "value": "https://selftournow.com/property/53bb81cd-9519-4c81-850f-74f9d8d78a9f/units"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "custom"
    },
    {
      "ID": "custom_eliseai_building_token",
      "type": "STRING",
      "value": "04d3a78c-ff94-11ef-9bb2-d7ade43b2b49"
    },
    {
      "ID": "custom_eliseai_organization_id",
      "type": "STRING",
      "value": "dba41761-2900-497b-8de7-41d7628b5018"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-543-2863"
    },
    {
      "ID": "custom_paid_social_tracking_phone_number",
      "type": "STRING",
      "value": "844-587-0064"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_repli_id": "12977262122",
  "custom_google_gtm_id": "GTM-WGVKTDMW",
  "custom_rollout_phase": "Phase 2",
  "custom_perq_script_url": "https://crescentvalleyhomes.fatwin.com/api/websites/resources/1?x=dTBTeTFxZVV4WWpJbFVueGlRNUhPSkhKRGN1VXRuckMyeXRWaExIcTZGR3lRV1BaOFdpZUdoanhBOVJEa3FEVFhRdkZKcU5KeXFOTk9Bb1dZdGxpRlE9PQ2",
  "custom_ads_subscription": "none",
  "custom_seo_subscription": "full_stack",
  "custom_hubspot_company_id": "57142570538",
  "custom_social_subscription": "none",
  "custom_engrain_sightmap_url": "https://sightmap.com/embed/yzvg89q1pln",
  "custom_self_guided_tour_url": "https://selftournow.com/property/53bb81cd-9519-4c81-850f-74f9d8d78a9f/units",
  "custom_website_subscription": "custom",
  "custom_eliseai_building_token": "04d3a78c-ff94-11ef-9bb2-d7ade43b2b49",
  "custom_eliseai_organization_id": "dba41761-2900-497b-8de7-41d7628b5018",
  "custom_ppc_tracking_phone_number": "844-543-2863",
  "custom_paid_social_tracking_phone_number": "844-587-0064",
  "custom_audioeye_site_id": "63c42e55-a185-4a3e-b670-473e456d9949",
  "custom_audioeye_site_hash": "d1b25c3c32ab1a2c2a7fc4cca12b4425"
};

export const generatedAt = '2026-10-29T18:35:32.930Z';
